import { useEffect, useRef, useState } from "react";
import Modal from 'react-modal';
// import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { FcDownload } from "react-icons/fc";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";
import Select from 'react-select';
import CreatableSelect from "react-select/creatable";
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import Swal from "sweetalert2";
import mail from '../../../Assets/Images/mail-reception-svgrepo-com.png';
import sms from '../../../Assets/Images/sms-svgrepo-com.png';
import whatsapp from '../../../Assets/Images/whatsapp-svgrepo-com.png';
import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";


function Booking({ selectedDocket, setSelectedDocket, selectedRateData, setSelectedRateData }) {
    const navigate = useNavigate();
    const location = useLocation();
    const kyc1Ref = useRef(null);
    const kyc2Ref = useRef(null);
    const [showKyc, setShowKyc] = useState({
        kyc1: "",
        kyc2: ""
    })
    const [edit, setEdit] = useState(false);
    const [kyc1, setKyc1] = useState(null);
    const [kyc2, setKyc2] = useState(null);
    const [inputValue, setInputValue] = useState("");
    const [inputValue1, setInputValue1] = useState("");
    const [inputValue3, setInputValue3] = useState("");
    const [inputValue2, setInputValue2] = useState("");
    const [skipGstCalc, setSkipGstCalc] = useState(false);
    const skipRateCalcRef = useRef(false);
    const [UseInput, setUseInput] = useState(0);

    const handleDownload = () => {
        if (!showKyc.kyc1) {
            alert("No file to download");
            return;
        }

        const link = document.createElement("a");
        link.href = showKyc.kyc1;
        link.download = "KYC1.png"; // or derive filename dynamically
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleDownload2 = () => {
        if (!showKyc.kyc2) {
            alert("No file to download");
            return;
        }

        const link = document.createElement("a");
        link.href = showKyc.kyc2;
        link.download = "KYC2.png"; // or derive filename dynamically
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };







    // Utility function to format date safely
    const formatDate = (inputDate) => {
        if (!inputDate) return null; // if undefined or null

        const date = new Date(inputDate);

        // Check if date is valid
        if (isNaN(date)) {
            console.error("Invalid date:", inputDate);
            return null;
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    // Convert JPG/JPEG/PNG → PNG (~8KB)
    const MAX_ORIGINAL_SIZE = 100 * 1024; // 100 KB
    const TARGET_SIZE = 100 * 1024;       // compressed target


    const convertToPng = (file) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const reader = new FileReader();

            reader.onload = () => {
                img.src = reader.result;
            };

            reader.onerror = reject;

            img.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                let width = img.width;
                let height = img.height;

                const compress = () => {
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0, width, height);

                    canvas.toBlob(
                        (blob) => {
                            if (!blob) return reject("Conversion failed");

                            if (blob.size <= TARGET_SIZE || width < 120) {
                                resolve(
                                    new File(
                                        [blob],
                                        file.name.replace(/\.\w+$/, ".png"),
                                        { type: "image/png" }
                                    )
                                );
                            } else {
                                width *= 0.75;
                                height *= 0.75;
                                compress();
                            }
                        },
                        "image/png"
                    );
                };

                compress();
            };

            reader.readAsDataURL(file);
        });
    };


    const handleFileChange = async (e, setFile) => {
        const file = e.target.files?.[0];
        if (!file) return;

        // ✅ Allow only JPG / PNG
        const allowedTypes = ["image/jpeg", "image/png"];
        if (!allowedTypes.includes(file.type)) {
            alert("Only JPG, JPEG, PNG images allowed");
            return;
        }

        // ✅ If original file already under 100KB → KEEP IT
        if (file.size <= MAX_ORIGINAL_SIZE) {
            setFile(file); // 🔥 original preserved
            return;
        }

        // 🔁 Else compress & convert
        try {
            const png = await convertToPng(file);
            setFile(png);
        } catch (error) {
            alert("Image compression failed");
        }
    };




    const [fecthed, setFecthed] = useState("");
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen1, setModalIsOpen1] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [modalIsOpen3, setModalIsOpen3] = useState(false);
    const [modalIsOpen4, setModalIsOpen4] = useState(false);
    const [modalIsOpen5, setModalIsOpen5] = useState(false);
    const [modalIsOpen6, setModalIsOpen6] = useState(false);
    const [modalIsOpen7, setModalIsOpen7] = useState(false);
    const [modalIsOpen8, setModalIsOpen8] = useState(false);
    const [modalIsOpen9, setModalIsOpen9] = useState(false);
    const [modalIsOpen10, setModalIsOpen10] = useState(false);
    const [modalIsOpen11, setModalIsOpen11] = useState(false);
    const [getReceiver, setGetReceiver] = useState([]);
    const [getCustomerdata, setgetCustomerdata] = useState([]);
    const [getVendor, setGetVendor] = useState([]);
    const [getState, setGetState] = useState([]);
    const [getCity, setGetCity] = useState([]);
    const [getMode, setGetMode] = useState([]);
    const [getFlight, setGetFlight] = useState([]);
    const [getTrain, setGetTrain] = useState([]);
    const [getProduct, setGetProduct] = useState([]);
    const [getDest, setDest] = useState([]);
    const [selectedModeName, setSelectedModeName] = useState('');
    const [getKyc, setGetKyc] = useState([]);
    const [toggleActive, setToggleActive] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [isChecked2, setIsChecked2] = useState({
        Package_Type: false,
        Vendor_Details: false,
        Shipper_Details: false,
        ShipperkycDetails: false,
        Consignee_Details: false,
        Flight_Name: false,
        Train_Name: false,
        Delivery_Charges: false,
        Hamali_Charges: false,
        ODA_Charges: false,
        Fov_Charges: false,
        Packing_Charges: false,
        Other_Charges: false,
        Fuel_Charges: false,
        Volumetric_Weight: false,
        Docket_Charges: false,
        Green_Charges: false,
        Insurance_Charges: false,
        Invoice_Value: false,
        Invoice_No: false,
        Remark_SR_No: false,
        EWay_Bill_No: false,
        Dispatch_Date: false,
    });
    const [isChecked, setIsChecked] = useState({
        charge1: false,  // Clearance Charges
        charge2: false,  // Security Surcharge
        charge3: false,  // D G R Charges
        charge4: false,  // Packing Charges
        charge5: false,  // Ad Code Reg.
        charge6: false,  // ADC Charges
        charge7: false,  // AWB Charges
        charge8: false,  // Large Size Charges
        charge9: false,  // Transportation Charges
        charge10: false, // Loading / Unloading
        charge11: false, // DHL Risk Charges
    });

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalVolWt, setTotalVolWt] = useState(0);
    const [totalActWt, setTotalActWt] = useState(0);
    const [totalChargeWt, setTotalChargeWt] = useState(0);
    const [totalVolWt1, setTotalVolWt1] = useState(0);
    const [totalActWt1, setTotalActWt1] = useState(0);
    const [totalChargeWt1, setTotalChargeWt1] = useState(0);
    const [note, setNote] = useState("");
    const [totalInvoiceValue, setTotalInvoiceValue] = useState(0);
    const [selectedOriginPinCode, setSelectedOriginPinCode] = useState("");
    const [selectedDestPinCode, setSelectedDestPinCode] = useState("");
    const [open, setOpen] = useState(false);
    const [allReceiverOption, setAllReceiverOption] = useState([]);
    const [allShipperOption, setAllShipperOption] = useState([]);
    const getTodayDate = () => {
        const today = new Date();
        return today;
    };

    const [label, setLabel] = useState({
        charge2: 'Clearance Charges',
        charge1: 'Security Charges',
        charge3: 'Add. Correction Charges',
        charge4: 'Risk Charges',
        charge5: 'DDP Charges',
        charge6: 'Restricted Charges',
        charge7: 'Remote Charges',
        charge8: 'Demand Charges',
        charge9: 'Loading / Unloading Charges',
        charge10: 'Non-Conveyable Charges',
        charge11: 'Packing Charges'
    });



    const [formData, setFormData] = useState({
        ActualShipper: "",
        ActualWt: 0,
        Branch_Code: "",
        BillParty: "Client-wise Bill",
        BookDate: getTodayDate(),
        BookMode: "",
        ChargedWt: 0,
        ConsigneeAdd1: "",
        ConsigneeAdd2: "",
        ConsigneeGST: "",
        ConsigneePin: "",
        ConsigneeState: "",
        Consignee_City: "",
        ConsigneeEmail: "",
        ConsigneeMob: "",
        ConsigneeName: "",
        ConsigneeCountry: "",
        Customer_Code: "",
        charge1: 0,
        charge2: 0,
        charge3: 0,
        charge4: 0,
        charge5: 0,
        charge6: 0,
        charge7: 0,
        charge8: 0,
        charge9: 0,
        charge10: 0,
        charge11: 0,
        DeliveryChrgs: 0,
        Dest_Zone: "",
        DestinationCode: "",
        DocketChrgs: 0,
        DocketNo: "",
        DoxSpx: "Dox",
        RateType: "Credit",
        DispatchDate: getTodayDate(),
        EwayBill: "",
        ExptDateOfDelvDt: "",
        Flight_Code: "",
        FovChrgs: 0,
        FovPer: 0,
        FuelCharges: 0,
        FuelPer: 0,
        GreenChrgs: 0,
        HamaliChrgs: 0,
        InsuranceChrgs: 0,
        InvDate: getTodayDate(),
        InvValue: 0,
        InvoiceNo: "",
        SkycType: "",
        SkycNo: "",
        Location_Code: "",
        Mode_Code: "",
        method: "Credit",
        ODAChrgs: 0,
        OriginCode: "",
        Origin_Zone: "",
        OtherCharges: 0,
        PackingChrgs: 0,
        QtyOrderEntry: 0,
        Rate: 0,
        RatePerkg: 0,
        RateType: "Weight",
        Receiver_Code: "",
        ShipperAdd: "",
        ShipperAdd2: "",
        ShipperAdd3: "",
        ShipperCity: "",
        ShipperEmail: "",
        ShipperPhone: "",
        ShipperPin: "",
        Shipper_GstNo: "",
        Shipper_Name: "",
        Shipper_StateCode: "",
        Status: "",
        TotalAmt: 0,
        TotalGST: 0,
        totalgstPer: 0,
        Train_Code: "",
        VendorRatePerkg: 0,
        VendorAmt: 0,
        VendorAwbNo: "",
        VendorWt: 0,
        Vendor_Code: "",
        VolumetricWt: 0,
        WebAgent: "",
        destZoneName: "",
        orgZoneName: ""

    });



    const loginData = JSON.parse(localStorage.getItem("Login"));

const showBasicRate =
  loginData?.UserType === "Admin" || 
  !formData?.BookMode ||
  (
    loginData?.UserType === "User" &&
    (
      !loginData?.RateType?.length ||
      loginData?.RateType
        ?.map(x => x?.toLowerCase().replace("-", " ").trim())
        .includes(
          formData?.BookMode?.toLowerCase().replace("-", " ").trim()
        )
    )
  );
    const [addShipper, setAddShipper] = useState({
        shipperCode: '',
        custCode: '',
        shipperName: '',
        shipperAdd1: '',
        shipperAdd2: '',
        shipperPin: '',
        cityCode: '',
        stateCode: '',
        shipperMob: '',
        shipperEmail: '',
        gstNo: '',
        company: '',
    });
    const [addReceiver, setAddReceiver] = useState({
        receiverCode: '',
        receiverName: '',
        receiverAdd1: '',
        receiverAdd2: '',
        receiverPin: '',
        cityCode: '',
        stateCode: '',
        receiverMob: '',
        receiverEmail: '',
        gstNo: '',
        hsnNo: '',
        sms: false,
        emailId: false,
        whatsApp: false
    })

    const [vendorData, setVendorData] = useState({
        Vendor_Code1: "",
        Vendor_Code2: "",
        VendorAwbNo1: "",
        VendorAwbNo2: ""
    });

    const [vendorShow, setVendorShow] = useState({
        Rate: 0,
        Fuel_Charges: 0,
        Fuel_Per: 0,
        Fov_Charges: 0,
        Fov_Per: 0,
        Docket_Charges: 0,
        ODA_Charges: 0,
        Delivery_Charges: 0,
        Packing_Charges: 0,
        Green_Charges: 0,
        Hamali_Charges: 0,
        Other_Charges: 0,
        Insurance_Charges: 0,
        Subtotal: 0,
        CGSTPer: 0,
        CGSTAmt: 0,
        SGSTPer: 0,
        SGSTAmt: 0,
        IGSTPer: 0,
        IGSTAmt: 0,
        TotalGST: 0,
        TotalAmount: 0
    });

    useEffect(() => {
        console.log("KYC1 changed:", kyc1);
    }, [kyc1]);

    const [gstData, setGstData] = useState({
        CGSTPer: 0,
        CGSTAMT: 0,
        SGSTPer: 0,
        SGSTAMT: 0,
        IGSTPer: 0,
        IGSTAMT: 0,
        GSTPer: 0,
        TotalGST: 0
    });

    const [remarkData, setRemarkData] = useState({
        Remark: "",
        MHWNo: "",
        invoiceType: "INVOICE",
        curr: "INR",
        inco: "DDU",
        note: "",
        noteCont: "",
    });
    const [vendorsubmittedData, setVendorSubmittedData] = useState([]);
    const [vendorVolumetric, setVendorvolumetric] = useState({
        Length: 0,
        Width: 0,
        Height: 0,
        Qty: 0,
        DivideBy: 0,
        cft: 0,
        VolmetricWt: 0,
        ActualWt: 0,
        ChargeWt: 0
    });
    const [editIndex, setEditIndex] = useState(null);
    const [InvoicesubmittedData, setInvoiceSubmittedData] = useState([]);
    const [invoiceData, setInvoiceData] = useState({
        PoNo: "",
        PoDate: getTodayDate(),
        Currency: "INR",
        InvoiceNo: "",
        InvoiceValue: 0,
        Description: "",
        Qty: 0,
        EWayBillNo: "",
        EwayBillDate: getTodayDate(),
        Remark: "",
        InvoiceImg: ""
    });

    const [PinvoicesubmittedData, setPinvoiceSubmittedData] = useState([]);
    const [PinvoiceData, setPinvoiceData] = useState({
        InvoiceNo: PinvoicesubmittedData.length + 1,
        InvoiceValue: "",
        DocketNO: "",
        InvoiceDate: getTodayDate(),
        Remark1: "",
        Remark2: "",
        Remark3: "",
        Description: "",
        HSCode: "",
        UnitType: "",
        Qty: 0,
        UnitRate: 0,
        Amount: 0,
    });

    const [submittedData, setSubmittedData] = useState([]);
    const [volumetricData, setVolumetricData] = useState({
        Length: 0,
        Width: 0,
        Height: 0,
        Qty: 0,
        DivideBy: 0,
        cft: 0,
        VolmetricWt: 0,
        ActualWt: 0,
        ChargeWt: 0
    })

        const fetchData = async (endpoint, setData) => {

        try {
            const response = await getApi(endpoint);
            const data = response.Data || response.data
            // Check if the response contains data, then update the corresponding state
            if (data) {
                setData(Array.isArray(data) ? data : []);
            } else {
                setData([]);
            }
        } catch (err) {
            console.error(`Error fetching data from ${endpoint}:`, err);

        }
    };
    const fetchCustData = async (setData) => {
        const user = JSON.parse(localStorage.getItem("Login"));

        try {
            const response = await getApi(`/Master/getCustomerdata?Branch_Code=${user?.Branch_Code}&Customer_Code=${user?.Customer_Code}`);
            const data = response.Data || response.data
            // Check if the response contains data, then update the corresponding state
            if (data) {
                setData(Array.isArray(data) ? data : []);
            } else {
                setData([]);
            }
        } catch (err) {
            console.error(`Error fetching data from customer data:`, err);

        }
    };
    useEffect(() => {
        fetchCustData(setgetCustomerdata);
        fetchData('/Master/GetReceiver', setGetReceiver);
        fetchData('/Master/getVendor', setGetVendor);
        fetchData('/Master/GetState', setGetState);
        fetchData('/Master/getMode', setGetMode);
        fetchData('/Master/GetAllFlights', setGetFlight);
        fetchData('/Master/GetAllTrains', setGetTrain);
        fetchData('/Master/GetAllProducts', setGetProduct);
        fetchData('/Master/GetKYCDetails', setGetKyc);
    }, []);

    useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem("Login"));

    console.log("Login Data:", loginData);

    const code = loginData?.Customer_Code;

    console.log("Customer Code:", code);
    console.log("Customer Data Array:", getCustomerdata);

    if (code && getCustomerdata.length > 0) {

        const found = getCustomerdata.find(
            c => String(c.Customer_Code) === String(code)
        );

        console.log("Found customer data:", found);

        if (found) {
            setFormData((prev) => ({
                ...prev,
                Customer_Code: code,
                BookMode: found.Booking_Type,
                Branch_Code: found.Branch_Code
            }));
        }
    }
}, [getCustomerdata]);





    // ===============================Enter Block =============================
    const handleKeyDown = (e) => {
        // Prevent Enter key from submitting or opening anything unintentionally
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    };
    useEffect(() => {
        console.log("KYC1:", formData.uploadkyc1);
    }, [formData.uploadkyc1]);


    const handleSearch = async (e, docket, source) => {
        // stop default tab/enter behavior
        if (e?.key === "Tab" || e?.key === "Enter") {
            e.preventDefault();
        }

        // helper for next input focus
        const focusNextField = () => {
    if (!e?.target?.form) return;

    const form = e.target.form;
    const index = [...form.elements].indexOf(e.target);

    form.elements[index + 2]?.focus();
};
        const docketNo = docket
        const fromPerforma = Boolean(docket); //

        // 🚫 no docket
        if (!docketNo) {
            return Swal.fire("Warning", "Enter Docket No", "warning");
        }

        // 🚫 already fetched
        if (fecthed === docketNo && docketNo !== '') {
            return Swal.fire(
                "Warning",
                `Docket ${docketNo} already Fetched`,
                "warning"
            );
        }

        try {
            setSkipGstCalc(true);
            const res = await getApi(`/Booking/getOrderByDocket?docketNo=${docketNo}`);
            if (res.Success === 1 && res.OrderEntry) {
                // ✅ SHOW SUCCESS ONLY FOR MANUAL SEARCH
                // ✅ SHOW SUCCESS ONLY FOR MANUAL SEARCH
                if (source === "manual") {
                    Swal.fire({
                        title: "Success!",
                        text: "Data Fetched Successfully",
                        icon: "success",
                        timer: 1000, // auto close after 1.5 sec
                        showConfirmButton: false,
                    });
                }
                setEdit(true);
                setFecthed(docket);
                const data = res.OrderEntry;

                try {
                    setShowKyc(pre => ({
                        ...pre,
                        kyc1: `https://jaimarutilogistics.com/wwwroot/${docketNo}/KYC1.png`,
                        kyc2: `https://jaimarutilogistics.com/wwwroot/${docketNo}/KYC2.png`
                    }));
                } catch (error) {
                    console.error(error);
                    alert("Fetched KYC failed");
                }



                // ✅ Extract Charges (FINAL)
                let labelData = {};
                let valueData = {};

                for (let i = 1; i <= 11; i++) {
                    try {
                        const obj = JSON.parse(data[`Charges${i}`] || '{}');
                        labelData[`charge${i}`] = obj.label?.trim() || '';
                        valueData[`charge${i}`] = Number(obj.value) || 0;

                    } catch {
                        labelData[`charge${i}`] = '';
                        valueData[`charge${i}`] = 0;
                    }
                }
                // ✅ Set Label
                setLabel(prev => ({
                    ...prev,
                    ...labelData
                }));



                setFormData(
                    prev => ({
                        ...prev,
                        Branch_Code: data.Location_Code,
                        DocketNo: data.DocketNo,
                        BookDate: data.BookDate,
                        Customer_Code: data.Customer_Code,
                        ConsigneeName: data.Receiver_Code ? data.Receiver_Code : data.Consignee_Name,
                        ConsigneeAdd1: data.Consignee_Add1,
                        ConsigneeAdd2: data.Consignee_Add2,
                        ConsigneeState: data.Consignee_State,
                        ConsigneePin: data.Consignee_Pin,
                        Consignee_City: data.Consignee_City,
                        ConsigneeMob: data.Consignee_Mob,
                        ConsigneeEmail: data.Consignee_Email,
                        ConsigneeGST: data.Consignee_GST,
                        ConsigneeCountry: data.Consignee_Country,
                        Mode_Code: data.Mode_Code,
                        OriginCode: data.Origin_code,
                        DestinationCode: data.Destination_Code,
                        Origin_Zone: data.Origin_Zone,
                        Dest_Zone: data.Dest_Zone,
                        orgZoneName: data.Origin_ZoneName,
                        destZoneName: data.Destination_ZoneName,
                        DispatchDate: data.DispatchDate,
                        DoxSpx: data.DoxSpx,
                        QtyOrderEntry: data.Qty,
                        ActualWt: data.ActualWt,
                        VendorWt: data.VendorWt,
                        VendorAmt: data.VendorAmt,
                        VolumetricWt: data.VolumetricWt,
                        ChargedWt: data.ChargedWt,
                        RatePerkg: data.RatePerKg,
                        Rate: data.Rate,
                        FuelPer: data.FuelPer,
                        FuelCharges: data.FuelCharges,        // ✅ matches API
                        FovChrgs: data.Fov_Chrgs,             // ✅ underscore in API
                        DocketChrgs: data.DocketChrgs,        // ✅ matches API
                        ODAChrgs: data.ODA_Chrgs,             // ✅ underscore in API
                        DeliveryChrgs: data.DeliveryChrgs,    // ✅ matches API
                        PackingChrgs: data.PackingChrgs,      // ✅ matches API
                        GreenChrgs: data.GreenChrgs,          // ✅ matches API
                        HamaliChrgs: data.HamaliChrgs,        // ✅ matches API
                        OtherCharges: data.OtherCharges,      // ✅ matches API
                        InsuranceChrgs: data.InsuranceChrgs,  // ✅ matches API
                        ...valueData,                             // ✅ dynamic charges
                        TotalAmt: data.TotalAmt,

                        Train_Code: data.Train_Code,
                        Flight_Code: data.Flight_Code,
                        SkycType: data.KYC_Type,
                        SkycNo: data.KYC_No,

                        uploadkyc1: res?.KYCPhoto[0]?.KYC_image_1,
                        uploadkyc2: res?.KYCPhoto[0]?.KYC_image_2,
                        Status: data.Remark,
                        Vendor_Code: data.Vendor_Code,
                        VendorAwbNo: data.VendorAwbNo,
                        WebAgent: "",
                        ExptDateOfDelvDt: data.ExptDateOfDelvDt,
                        Shipper_Name: data.Shipper_Code ? data.Shipper_Code : data.Shipper_Name,
                        ShipperAdd: data.ShipperAdd,
                        ShipperAdd2: data.ShipperAdd2,
                        ShipperAdd3: data.ShipperAdd3,
                        ShipperPin: data.ShipperPin,
                        ShipperPhone: data.ShipperPhone,
                        ShipperCity: data.ShipperCity,
                        Shipper_StateCode: data.Shipper_StateCode,
                        Shipper_GstNo: data.Shipper_GstNo,
                        ShipperEmail: data.ShipperEmail,
                        UserName: data.UserName,
                        InvoiceNo: data.InvoiceNo,
                        InvValue: data.InvValue,
                        EwayBill: data.EwayBill,
                        InvDate: data.InvDate,
                        BillParty: data.BillParty,
                        BookMode: data.T_Flag,
                        TotalGST: data.CGSTAMT + data.SGSTAMT + data.IGSTAMT,
                        totalgstPer: data.CGSTPer + data.SGSTPer + data.IGSTPer,

                    }));
                setGstData(pre => ({
                    ...pre,
                    CGSTPer: data.CGSTPer,
                    CGSTAMT: data.CGSTAMT,
                    SGSTPer: data.SGSTPer,
                    SGSTAMT: data.SGSTAMT,
                    IGSTPer: data.IGSTPer,
                    IGSTAMT: data.IGSTAMT,
                    GSTPer: data.CGSTPer + data.SGSTPer + data.IGSTPer,
                    TotalGST: data.CGSTAMT + data.SGSTAMT + data.IGSTAMT,
                })
                )
                setRemarkData(pre => ({
                    ...pre,
                    Remark: data.Remark,
                    MHWNo: data.MHWNo,
                    inco: data.Remark1,
                    note: data.Remark2,
                    noteCont: data.Remark3,
                }));
                setSelectedOriginPinCode(data.Origin_Pincode);
                setSelectedDestPinCode(data.Dest_PinCode);

                const multiInvoice = res?.MultiInvoice || [];


                const formattedInvoices = multiInvoice.length > 0 ? multiInvoice.map(item => ({
                    PoNo: item.PoNo || "",
                    PoDate: new Date(item.PoDate) || "",
                    InvoiceNo: item.InvNo || "",
                    InvoiceValue: item.InvValue || "",
                    Description: item.Description || "",
                    Qty: item.Qty || 0,
                    EWayBillNo: item.EWayBill || "",
                    Remark: item.Remark || "",
                    InvoiceImg: item.InvoiceImg || ""
                })) : [];
                setInvoiceSubmittedData(formattedInvoices);
                setSubmittedData(res?.Volumetric);
                setVendorSubmittedData(res?.VendorVolumetric);
                setPinvoiceSubmittedData(res?.ProformaDetail);
                // ✅ allow GST calculation AFTER formData update
                setSkipGstCalc(true);
                setTimeout(() => {
                    setSkipGstCalc(false);
                }, 1000);

                return true; // data found



            } else {
                // Swal.fire("Not Found", res.message || "Booking not found.", "info");
                setSkipGstCalc(false);
                setEdit(false);
                // move next input if not found
                if (e?.key === "Tab") {
                    focusNextField();
                }
            }
        } catch (err) {
            // Swal.fire("Error", "Failed to fetch booking data.", "error");
            if (e?.key === "Tab") {
                focusNextField();
            }
            setSkipGstCalc(false);
            setEdit(false);
            return false;
        }
    };
    useEffect(() => {
        if (!selectedDocket) return;

        // 1️⃣ set docket in form
        setFormData(prev => ({
            ...prev,
            DocketNo: selectedDocket,
        }));

        // 2️⃣ force toggle ON (from Performa)
        setToggleActive(true);

        // 3️⃣ auto search (no Swal)
        handleSearch(null,selectedDocket, "performa");

        // 4️⃣ clear
        setSelectedDocket(null);

    }, [selectedDocket]);


    useEffect(() => {
        const fetchData = async (setData, Product_Type) => {


            try {
                const response = await getApi(`/Master/GetInterDomestic?Product_Type=${Product_Type}`);
                const data = response.Data || response.data
                // Check if the response contains data, then update the corresponding state
                if (data) {
                    setData(Array.isArray(data) ? data : []);
                } else {
                    setData([]);
                }
            } catch (err) {
                console.error(`Error fetching data from /Master/GetInterDomestic:`, err);

            }

        };
        const Product_Type = getMode.find(m => m.Mode_Code === formData.Mode_Code)?.Mode_Type || "Domestic"
        fetchData(setGetCity, Product_Type);
    }, [formData.Mode_Code, getMode])


    useEffect(() => {
        const fetchData = async (setData, Product_Type) => {


            try {
                const response = await getApi(`/Master/InTernationalDomestic?Product_Type=${Product_Type}&Vendor_Code=${formData.Vendor_Code}`);
                const data = response.Data || response.data
                // Check if the response contains data, then update the corresponding state
                if (data) {
                    setData(Array.isArray(data) ? data : []);
                } else {
                    setData([]);
                }
            } catch (err) {
                console.error(`Error fetching data from /Master/InTernationalDomestic:`, err);

            }

        };
        const Product_Type = getMode.find(m => m.Mode_Code === formData.Mode_Code)?.Mode_Type || "International"
        fetchData(setDest, Product_Type);
    }, [formData.Mode_Code, formData.Vendor_Code, getMode, getVendor])

    useEffect(() => {

        const fetchAllData = async () => {
            try {
                // ✅ 1. Get Charges Label Data
                const chargesRes = await getApi('/Master/getOrderBookingCharges');

                if (chargesRes?.status === 1 && chargesRes?.Data?.length > 0 && !skipGstCalc) {
                    const data = chargesRes.Data[0];

                    // 🔥 Dynamic mapping (BEST WAY)
                    let labelData = {};
                    for (let i = 1; i <= 11; i++) {
                        labelData[`charge${i}`] = data[`Charge${i}_Name`] || '';
                    }

                    // setLabel(labelData);
                }

                // ✅ 2. Get Setup Data (your existing API)
                const setupRes = await getApi('/Master/GetOrderEntrySetup');

                if (setupRes?.status === 1 && setupRes.data?.length > 0) {
                    const setup = setupRes.data[0];

                    // Order Entry fields
                    setIsChecked2(prev => ({
                        ...prev,
                        Package_Type: setup.Package_Type,
                        Vendor_Details: setup.Vendor_Details,
                        Shipper_Details: setup.Shipper_Details,
                        ShipperkycDetails: setup.ShipperkycDetails,
                        Consignee_Details: setup.Consignee_Details,
                        Flight_Name: setup.Flight_Name,
                        Train_Name: setup.Train_Name,
                        Delivery_Charges: setup.Delivery_Charges,
                        Hamali_Charges: setup.Hamali_Charges,
                        ODA_Charges: setup.ODA_Charges,
                        Fov_Charges: setup.FOV_Charges,
                        Packing_Charges: setup.Packing_Charges,
                        Other_Charges: setup.Other_Charges,
                        Fuel_Charges: setup.Fuel_Charges,
                        Volumetric_Weight: setup.Volumetric_Weight,
                        Docket_Charges: setup.Docket_Charges,
                        Green_Charges: setup.Green_Charges,
                        Insurance_Charges: setup.Insurance_Charges,
                        Invoice_Value: setup.Invoice_Value,
                        Invoice_No: setup.Invoice_No,
                        Remark_SR_No: setup.Remark_SR_No,
                        EWay_Bill_No: setup.EWay_Bill_No,
                        Dispatch_Date: setup.Dispatch_Date,
                    }));

                    // Charges checkbox
                    let chargeChecked = {};
                    for (let i = 1; i <= 11; i++) {
                        chargeChecked[`charge${i}`] = setup[`Charges${i}`];
                    }

                    setIsChecked(prev => ({
                        ...prev,
                        ...chargeChecked
                    }));

                    setIsAllChecked(Boolean(setup.All_Select));
                }

            } catch (error) {
                console.log(error);
            }
        };

        fetchAllData();

    }, []);
    const preparePayload = () => {
        let payload = {
            ID: 1
        };

        for (let i = 1; i <= 11; i++) {
            payload[`Charge${i}_Name`] = label[`charge${i}`];
            payload[`Charge${i}_Value`] = 0; // assuming values state
        }

        return payload;
    };
    const handleLabelUpdate = async (e) => {
        e.preventDefault();
        try {
            const payload = preparePayload();
            const res = await postApi('/Master/updateOrderBookingCharges', payload);

            if (res.status === 1) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: res?.message || 'Updated Successfully',
                });

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: res?.message || 'Update failed',
                });
            }

        } catch (error) {
            console.error(error);
        }
    };

    const handleUpdateSetup = async (e) => {
        e.preventDefault();


        const requestPayload = {
            ID: 1, // 🔴 required
            All_Select: isAllChecked,

            // ===== Order Entry Setup (isChecked2) =====
            Package_Type: isChecked2.Package_Type,
            Vendor_Details: isChecked2.Vendor_Details,
            Shipper_Details: isChecked2.Shipper_Details,
            ShipperkycDetails: isChecked2.ShipperkycDetails,
            Consignee_Details: isChecked2.Consignee_Details,
            Flight_Name: isChecked2.Flight_Name,
            Train_Name: isChecked2.Train_Name,
            Delivery_Charges: isChecked2.Delivery_Charges,
            Hamali_Charges: isChecked2.Hamali_Charges,
            ODA_Charges: isChecked2.ODA_Charges,
            FOV_Charges: isChecked2.Fov_Charges,
            Packing_Charges: isChecked2.Packing_Charges,
            Other_Charges: isChecked2.Other_Charges,
            Fuel_Charges: isChecked2.Fuel_Charges,
            Volumetric_Weight: isChecked2.Volumetric_Weight,
            Docket_Charges: isChecked2.Docket_Charges,
            Green_Charges: isChecked2.Green_Charges,
            Insurance_Charges: isChecked2.Insurance_Charges,
            Invoice_Value: isChecked2.Invoice_Value,
            Invoice_No: isChecked2.Invoice_No,
            Remark_SR_No: isChecked2.Remark_SR_No,
            EWay_Bill_No: isChecked2.EWay_Bill_No,
            Dispatch_Date: isChecked2.Dispatch_Date,
            Charges1: isChecked.charge1,
            Charges2: isChecked.charge2,
            Charges3: isChecked.charge3,
            Charges4: isChecked.charge4,
            Charges5: isChecked.charge5,
            Charges6: isChecked.charge6,
            Charges7: isChecked.charge7,
            Charges8: isChecked.charge8,
            Charges9: isChecked.charge9,
            Charges10: isChecked.charge10,
            Charges11: isChecked.charge11,

        };

        try {
            const response = await postApi(
                '/Master/UpdateOrderEntrySetup',
                requestPayload
            );

            if (response?.status === 1) {
                setModalIsOpen7(false);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response?.message || 'Update failed',
                });
            }
        } catch (error) {
            console.error("Update Error:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong while updating setup.',
            });
        }
    };

    const handleDateChange = (date, field) => {
        setFormData({ ...formData, [field]: date });
    };




    const handleOriginPinCodeChange = async (e) => {
        const pincode = e.target.value;
        setSelectedOriginPinCode(pincode);

        if (pincode.length === 6 && /^[0-9]+$/.test(pincode)) {
            try {
                const response = await getApi(`/Master/PincodeFinder?pincode=${pincode}`);
                if (response.status === 1 && Array.isArray(response.data) && response.data.length > 0) {
                    const { City_Name, City_Code, Zone_Name, Zone_Code } = response.data[0];
                    setFormData(prev => ({
                        ...prev,
                        OriginCode: City_Code || "",
                        Origin_code: City_Name || "",
                        Origin_Zone: Zone_Code || "",
                        orgZoneName: Zone_Name || "",


                    }));
                } else {
                    setFormData(prev => ({
                        ...prev,
                        OriginCode: "",
                        Origin_code: "",
                        Origin_Zone: "",
                        orgZoneName: "",
                    }));
                }
            } catch (error) {
                console.error("Failed to fetch pincode info:", error);
            }
        }
    };

    // ✅ Destination pincode change
    const handleDestPinCodeChange = async (e) => {
        const pincode = e.target.value;
        setSelectedDestPinCode(pincode);

        if (pincode.length === 6 && /^[0-9]+$/.test(pincode)) {
            try {
                const response = await getApi(`/Master/PincodeFinder?pincode=${pincode}`);
                if (response.status === 1 && Array.isArray(response.data) && response.data.length > 0) {
                    const { City_Name, City_Code, Zone_Name, Zone_Code, State_Name } = response.data[0];
                    setFormData(prev => ({
                        ...prev,
                        DestinationCode: City_Code || "",
                        City_Name: City_Name || "",
                        Dest_Zone: Zone_Code || "",
                        destZoneName: Zone_Name || "",
                        ConsigneeState: State_Name,
                        ConsigneeCountry: City_Name,
                        ConsigneePin: pincode,
                    }));

                } else {
                    setFormData(prev => ({
                        ...prev,
                        DestinationCode: "",
                        City_Name: "",
                        Dest_Zone: "",
                        destZoneName: "",
                        ConsigneePin: "",
                    }));
                }
            } catch (error) {
                console.error("Failed to fetch pincode info:", error);
            }
        }
    };




    const handleGenerateCode = () => {
        if (addShipper.shipperCode !== '') return;
        const newCode = `${Math.floor(Math.random() * 1000)}`;
        setAddShipper({ ...addShipper, shipperCode: newCode });
    };
    const handleGenerateCode1 = () => {
        if (addReceiver.receiverCode !== '') return;
        const newCode1 = `${Math.floor(Math.random() * 1000)}`;
        setAddReceiver({ ...addReceiver, receiverCode: newCode1 });
    };
    // Fetch receiver list from API and clean data
    const handleSaveReceiverFromBooking = async (e) => {
        e.preventDefault(); // Prevent page reload
        try {
            const requestBody = {
                receiverCode: "", // Auto-generate in backend if needed
                receiverName: formData.ConsigneeName,
                receiverAdd1: formData.ConsigneeAdd1,
                receiverAdd2: formData.ConsigneeAdd2,
                receiverPin: formData.ConsigneePin || "",
                cityCode: formData.Consignee_City || "",
                stateCode: formData.ConsigneeState || "",
                receiverMob: formData.ConsigneeMob,
                receiverEmail: formData.ConsigneeEmail,
                gstNo: formData.ConsigneeGST,
                hsnNo: "",
                sms: "",
                emailId: "",
                whatApp: ""
            };


            const response = await postApi("/Master/AddReceiver", requestBody, "POST");

            if (response.status === 1) {
                Swal.fire("Success", "Receiver saved successfully.", "success");

                // ✅ Refresh list
                await fetchReceiverData();

                // ✅ Auto-select newly added receiver
                setFormData((prev) => ({
                    ...prev,
                    ConsigneeName: requestBody.receiverName
                }));

                // ✅ Close modal after save
                setModalIsOpen1(false);
            } else {
                Swal.fire("Error", response.message || "Save failed", "error");
            }
        } catch (err) {
            console.error("API Error", err);
            Swal.fire("Error", "Something went wrong", "error");
        }
    };

    const fetchReceiverData = async () => {
        try {
            const response = await getApi("/Master/GetReceiver");

            if (Array.isArray(response.Data)) {
                const cleanedData = response.Data.map((receiver) => ({
                    value: receiver.Receiver_Code,
                    label: receiver.Receiver_Name?.trim() || "",
                    Receiver_Email: receiver.Receiver_Email?.trim() || "",
                    Receiver_Mob: receiver.Receiver_Mob?.trim() || "",
                    Receiver_Add1: receiver.Receiver_Add1?.trim() || "",
                    Receiver_Add2: receiver.Receiver_Add2?.trim() || "",
                    Receiver_Pin: receiver.Receiver_Pin?.trim() || "",
                    GSTNo: receiver.GSTNo?.trim() || "",
                    State_Code: receiver.State_Code?.trim() || "",
                    City_Code: receiver.City_Code?.trim() || "",
                    City_Name: receiver.City_Name?.trim() || "",
                    State_Name: receiver.State_Name?.trim() || "",

                }));
                console.log(cleanedData);
                setAllReceiverOption(cleanedData);
            } else {
                console.warn("Receiver API returned no data.");
                setAllReceiverOption([]);
            }
        } catch (error) {
            console.error("Error fetching receiver data:", error);
        }
    };
    const fetchShipper = async () => {
        try {
            const response = await getApi("/Master/GetSmartShipperMaster");

            if (response.status === 1 && Array.isArray(response.data)) {
                const cleanedData = response.data.map((shipper) => ({
                    value: shipper.Shipper_Code,
                    label: shipper.Shipper_Name?.trim() || "",
                    shipper_Email: shipper.Email?.trim() || "",
                    shipper_Mob: shipper.Mobile?.trim() || "",
                    shipper_Add1: shipper.Add1?.trim() || "",
                    shipper_Add2: shipper.Add2?.trim() || "",
                    shipper_Add3: shipper.Add3?.trim() || "",
                    shipper_Pin: shipper.Pin?.trim() || "",
                    GSTNo: shipper.GSTNo?.trim() || "",
                    State_Code: shipper.State_Code?.trim() || "",
                    City_Code: shipper.City_Code?.trim() || "",
                    City_Name: shipper.City_Name?.trim() || "",
                    State_Name: shipper.State_Name?.trim() || "",
                }));
                console.log(cleanedData);
                setAllShipperOption(cleanedData);
            } else {
                console.warn("Receiver API returned no data.");
                setAllShipperOption([]);
            }
        } catch (error) {
            console.error("Error fetching receiver data:", error);
        }
    };

    useEffect(() => {
        fetchReceiverData();
        fetchShipper();
    }, [])
    // =======================================================================




    const handleCheckChange = (e) => {
        const { name, checked } = e.target;

        if (name === "all") {
            setIsAllChecked(checked);

            setIsChecked(prev =>
                Object.fromEntries(Object.keys(prev).map(k => [k, checked]))
            );

            setIsChecked2(prev =>
                Object.fromEntries(Object.keys(prev).map(k => [k, checked]))
            );

            return;
        }


        // ✅ If checkbox belongs to isChecked
        if (name in isChecked) {
            setIsChecked(prev => {
                const updated = { ...prev, [name]: checked };

                const allSelected =
                    Object.values(updated).every(Boolean) &&
                    Object.values(isChecked2).every(Boolean);

                setIsAllChecked(allSelected);
                return updated;
            });
        }

        // ✅ If checkbox belongs to isChecked2
        if (name in isChecked2) {
            setIsChecked2(prev => {
                const updated = { ...prev, [name]: checked };

                const allSelected =
                    Object.values(isChecked).every(Boolean) &&
                    Object.values(updated).every(Boolean);

                setIsAllChecked(allSelected);
                return updated;
            });
        }
    };




    const handleSaveReceiver = async (e) => {
        e.preventDefault();
        const errors = [];
        if (!addReceiver.receiverCode) errors.push("Consignee Code is required");
        if (!addReceiver.receiverName) errors.push("Consignee Name is required");
        if (!addReceiver.cityCode) errors.push("City Code is required");
        if (!addReceiver.stateCode) errors.push("State Code is required");
        if (errors.length > 0) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                html: errors.map(err => `<div>${err}</div>`).join(''),
            });
            return;
        }
        const requestBody = {
            receiverCode: addReceiver.receiverCode,
            receiverName: addReceiver.receiverName,
            receiverAdd1: addReceiver.receiverAdd1,
            receiverAdd2: addReceiver.receiverAdd2,
            receiverPin: addReceiver.receiverPin,
            cityCode: addReceiver.cityCode,
            stateCode: addReceiver.stateCode,
            receiverMob: addReceiver.receiverMob,
            receiverEmail: addReceiver.receiverEmail,
            gstNo: addReceiver.gstNo.toUpperCase(),
            hsnNo: addReceiver.hsnNo,
            sms: addReceiver.sms,
            emailId: addReceiver.emailId,
            whatsApp: addReceiver.whatsApp
        }

        try {
            const response = await postApi('/Master/AddReceiver', requestBody, 'POST')
            if (response.status === 1) {
                setGetReceiver([...getReceiver, response.Data]);
                setAddReceiver({
                    receiverCode: '',
                    receiverName: '',
                    receiverAdd1: '',
                    receiverAdd2: '',
                    receiverPin: '',
                    cityCode: '',
                    stateCode: '',
                    receiverMob: '',
                    receiverEmail: '',
                    gstNo: '',
                    hsnNo: '',
                    sms: false,
                    emailId: false,
                    whatApp: false
                });
                Swal.fire('Saved!', response.message || 'Your changes have been saved.', 'success');
                setModalIsOpen1(false);
                await fetchReceiverData();
            } else {
                Swal.fire('Error!', response.message || 'Your changes have been saved.', 'error');
            }
        } catch (err) {
            console.error('Save Error:', err);
            Swal.fire('Error', 'Failed to add branch data', 'error');
        }
    };

    const handleSaveShipper = async (e) => {
        e.preventDefault();
        const errors = [];
        if (!addShipper.shipperCode) errors.push("Shipper Code is required");
        if (!addShipper.shipperName) errors.push("Shipper Name is required");
        if (!addShipper.cityCode) errors.push("City Code is required");
        if (!addShipper.stateCode) errors.push("State Code is required");
        if (errors.length > 0) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                html: errors.map(err => `<div>${err}</div>`).join(''),
            });
            return;
        }
        const requestBody = {
            shipperCode: addShipper.shipperCode,
            // customerCode: addReceiver.custCode,
            shipperName: addShipper.shipperName,
            add1: addShipper.shipperAdd1,
            add2: addShipper.shipperAdd2,
            pin: addShipper.shipperPin,
            mobile: addShipper.shipperMob,
            stateCode: addShipper.stateCode,
            gstNo: addShipper.gstNo.toUpperCase(),
            email: addShipper.shipperEmail,
            cityCode: addShipper.cityCode,
            companyName: addShipper.company
        };

        try {
            const response = await postApi('/Master/AddShippmerMaster', requestBody, 'POST')
            if (response.status === 1) {
                setAddShipper({
                    shipperCode: '',
                    custCode: '',
                    shipperName: '',
                    shipperAdd1: '',
                    shipperAdd2: '',
                    shipperPin: '',
                    cityCode: '',
                    stateCode: '',
                    shipperMob: '',
                    shipperEmail: '',
                    gstNo: '',
                    company: '',
                });
                Swal.fire('Saved!', response.message || 'Your changes have been saved.', 'success');
                setModalIsOpen(false);
                await fetchShipper();

            } else {
                Swal.fire('Error!', response.message || 'Your changes have been saved.', 'error');
            }
        } catch (err) {
            console.error('Save Error:', err);
            Swal.fire('Error', 'Failed to add branch data', 'error');
        }
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        setVolumetricData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleVendorChange = (e) => {
        const { name, value } = e.target;
        setVendorvolumetric((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleInvoiceDetailChange = (e) => {
        const { name, value } = e.target;
        setInvoiceData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handlePinvoiceDetailChange = (e) => {
        const { name, value } = e.target;
        setPinvoiceData((prev) => ({
            ...prev,
            [name]: value,
        }));

    };
    useEffect(() => {
        const totalVol1 = submittedData.reduce(
            (acc, d) => acc + parseFloat(d.VolmetricWt || 0), 0
        );
        const totalAct1 = submittedData.reduce(
            (acc, d) => acc + parseFloat(d.ActualWt || 0), 0
        );
        const totalCharge1 = submittedData.reduce(
            (acc, d) => acc + parseFloat(d.ChargeWt || 0), 0
        );

        setTotalVolWt1(totalVol1);
        setTotalActWt1(totalAct1);
        setTotalChargeWt1(totalCharge1);
        if (submittedData.length == 0) {
            return;
        }

        setFormData((prev) => ({
            ...prev,
            ActualWt: totalAct1,
            VolumetricWt: totalVol1,
            ChargedWt: totalCharge1,
        }));
    }, [submittedData]);

    useEffect(() => {
        const total = PinvoicesubmittedData.reduce(
            (acc, d) => acc + parseFloat(d.Amount || 0), 0
        );
        setPinvoiceData({
            InvoiceNo: PinvoicesubmittedData.length + 1,
            InvoiceValue: "",
            DocketNO: "",
            InvoiceDate: getTodayDate(),
            Remark1: "",
            Remark2: "",
            Remark3: "",
            Description: "",
            HSCode: "",
            UnitType: "",
            Qty: 0,
            UnitRate: 0,
            Amount: 0,
        });
        setInputValue3('');
        setInputValue2('');
        if (PinvoicesubmittedData.length == 0) {
            return;
        }
        setTotalInvoiceValue(total);
    }, [PinvoicesubmittedData]);
    useEffect(() => {

        const totalVol = vendorsubmittedData.reduce((acc, data) => acc + parseFloat(data.VolmetricWt || 0), 0);
        const totalAct = vendorsubmittedData.reduce((acc, data) => acc + parseFloat(data.ActualWt || 0), 0);
        const totalCharge = vendorsubmittedData.reduce((acc, data) => acc + parseFloat(data.ChargeWt || 0), 0);

        setTotalVolWt(totalVol);
        setTotalActWt(totalAct);
        setTotalChargeWt(totalCharge);

        if (vendorsubmittedData.length == 0) {
            return;
        }
        setFormData((prev) => ({
            ...prev,
            VendorWt: totalAct,
        }));
    }, [vendorsubmittedData]);



    const handleAddRow = (e) => {
        e.preventDefault();

        if (!volumetricData.ActualWt || !volumetricData.ChargeWt || !volumetricData.VolmetricWt) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Please fill in the empty fields.',
                confirmButtonText: 'OK',
            });
            return;
        }
        if (!volumetricData.Qty) {
            Swal.fire({
                icon: 'warning',
                title: 'Qty Zero',
                text: 'Qty should not be zero.',
                confirmButtonText: 'OK',
            });
            return;
        }
        if (editIndex !== null) {
            // update existing row
            const updated = [...submittedData];
            updated[editIndex] = volumetricData;
            setSubmittedData(updated);
            setEditIndex(null);
        } else {
            // add new row
            setSubmittedData((prev) => [...prev, volumetricData]);
        }
        setVolumetricData(pre => ({
            ...pre,
            Length: 0,
            Width: 0,
            Height: 0,
            Qty: 0,
            VolmetricWt: 0,
            ActualWt: 0,
            ChargeWt: 0,
        }));
    };

    const handleVendorAddRow = (e) => {
        e.preventDefault();

        if (!vendorVolumetric.ActualWt || !vendorVolumetric.ChargeWt) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Please fill in the empty fields.',
                confirmButtonText: 'OK',
            });
            return;
        }
        if (editIndex !== null) {
            // update existing row
            const updated = [...vendorsubmittedData];
            updated[editIndex] = vendorVolumetric;
            setVendorSubmittedData(updated);
            setEditIndex(null);
        } else {
            // add new row
            setVendorSubmittedData((prev) => [...prev, vendorVolumetric]);
        }
        setVendorvolumetric(pre => ({
            ...pre,
            Length: 0,
            Width: 0,
            Height: 0,
            Qty: 0,
            VolmetricWt: 0,
            ActualWt: 0,
            ChargeWt: 0,
        }));
    };

    const handleInvoiceAddRow = (e) => {
        e.preventDefault();

        if (!invoiceData.EWayBillNo || !invoiceData.InvoiceNo || !invoiceData.InvoiceValue || !invoiceData.PoDate || !invoiceData.PoNo || !invoiceData.Qty) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Please fill in the empty fields.',
                confirmButtonText: 'OK',
            });
            return;
        }
        if (editIndex !== null && InvoicesubmittedData[editIndex]) {
            // Update existing row
            const originalInvoice = InvoicesubmittedData[editIndex];
            const oldInvoice = [...InvoicesubmittedData];
            oldInvoice[editIndex] = invoiceData;
            setInvoiceSubmittedData(oldInvoice);
            setEditIndex(null); // reset edit mode
            // 2️⃣ Update formData

            setFormData((prev) => {
                const replaceInCSV = (csv, oldValue, newValue) => {
                    if (!csv) return "";
                    return csv
                        .split(",")
                        .map(item => item.trim().toLowerCase() === oldValue.toLowerCase() ? newValue : item.trim())
                        .join(",");
                };

                return {
                    ...prev,
                    InvoiceNo: replaceInCSV(prev.InvoiceNo || "", originalInvoice.InvoiceNo || "", invoiceData.InvoiceNo || ""),
                    InvValue: (Number(prev.InvValue || 0) - Number(originalInvoice.InvoiceValue || 0)) + Number(invoiceData.InvoiceValue || 0),
                    EwayBill: replaceInCSV(prev.EwayBill || "", originalInvoice.EWayBillNo || "", invoiceData.EWayBillNo || ""),
                };
            });


        } else {
            setInvoiceSubmittedData([...InvoicesubmittedData, invoiceData]);
            setFormData((prev) => ({
                ...prev,
                InvoiceNo: prev.InvoiceNo
                    ? prev.InvoiceNo + "," + invoiceData.InvoiceNo
                    : invoiceData.InvoiceNo,
                InvValue: Number(prev.InvValue || 0) + Number(invoiceData.InvoiceValue || 0),
                EwayBill: prev.EwayBill
                    ? prev.EwayBill + "," + invoiceData.EWayBillNo
                    : invoiceData.EWayBillNo,
            }));
        }

        setInvoiceData({
            PoNo: "",
            PoDate: getTodayDate(),
            Currency: "INR",
            InvoiceNo: "",
            InvoiceValue: 0,
            Description: "",
            Qty: 0,
            EWayBillNo: "",
            EwayBillDate: getTodayDate(),
            Remark: "",
            InvoiceImg: ""
        });
    };
    const handlePinvoiceAddRow = (e) => {
        e.preventDefault();
        console.log(PinvoiceData);

        if (!PinvoiceData.InvoiceNo || !PinvoiceData.Qty || !PinvoiceData.UnitRate) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Please fill in the empty fields.',
                confirmButtonText: 'OK',
            });
            return;
        }
        if (editIndex !== null && PinvoicesubmittedData[editIndex]) {
            // Update existing row
            const oldInvoice = [...PinvoicesubmittedData];
            oldInvoice[editIndex] = PinvoiceData;
            setPinvoiceSubmittedData(oldInvoice);
            setEditIndex(null); // reset edit mode


        } else {
            setPinvoiceSubmittedData([...PinvoicesubmittedData, PinvoiceData]);
        }


    };

    // =================================close weight ==============================




    useEffect(() => {
        const fetchCustomerData = async () => {
            try {
                const response = await getApi('/Master/getCustomerdata');
                if (response?.length) {
                    setgetCustomerdata(response);
                    console.log('✅ Customer data loaded');
                }
            } catch (err) {
                console.error('🚨 Error loading customer data:', err);
            }
        };
        fetchCustomerData();
    }, []);

    // 🔁 Fetch Mode Data
    useEffect(() => {
        const fetchModeData = async () => {
            try {
                const response = await getApi('/Master/getMode');
                if (response?.length) {
                    setGetMode(response);
                    console.log('✅ Mode data loaded');
                }
            } catch (err) {
                console.error('🚨 Error loading mode data:', err);
            }
        };
        fetchModeData();
    }, []);



    // ✅ Keep only this
    const handleShipperChange = (selectedOption) => {
        if (selectedOption) {
            // ✅ Immediately show the label (for existing or created options)
            setFormData((prev) => ({
                ...prev,
                Shipper_Name: selectedOption.value,
                ShipperAdd: selectedOption.shipper_Add1,
                ShipperAdd2: selectedOption.shipper_Add2,
                ShipperAdd3: selectedOption.City_Name,
                ShipperCity: selectedOption.City_Code,
                Shipper_StateCode: selectedOption.State_Code,
                Shipper_GstNo: selectedOption.GSTNo,
                ShipperPin: selectedOption.shipper_Pin,
                ShipperPhone: selectedOption.shipper_Mob,
                ShipperEmail: selectedOption.shipper_Email,
            }));
        } else {
            setFormData((prev) => ({ ...prev, Shipper_Name: "" }));
        }
        setInputValue("");
    };






    useEffect(() => {
        const calculateVenGstDetails = async () => {
            try {
                const {
                    Vendor_Code,
                    Mode_Code,
                    VendorAmt,
                } = formData;

                if (!Vendor_Code || !Mode_Code || !VendorAmt) return;

                const body = {
                    Vendor_Code: Vendor_Code,
                    Mode_Code: Mode_Code,
                    Rate: VendorAmt,
                    UseInput: UseInput,
                };

                const response = await postApi(`/Master/VendorcalculateGST`, body);

                const gst = response.Data;
                console.log("✅ GST API Response:", gst);
                setUseInput(gst?.Success);
                console.log(`input==${gst?.Success}`);

                const Rate = gst.Rate == 0 ? formData.VendorAmt : gst.Rate;
                const Subtotal = gst.Rate == 0 ? formData.VendorAmt : gst.Rate;
                const TotalAmount = gst.Rate == 0 ? formData.VendorAmt : gst.Rate;

                setVendorShow(prev => ({
                    ...prev,
                    Rate: Rate,
                    Fuel_Charges: gst.Fuel_Charges,
                    Fuel_Per: gst.Fuel_Per,
                    Fov_Charges: gst.Fov_Charges,
                    Fov_Per: gst.Fov_Per,
                    Docket_Charges: gst.Docket_Charges,
                    ODA_Charges: gst.ODA_Charges,
                    Delivery_Charges: gst.Delivery_Charges,
                    Packing_Charges: gst.Packing_Charges,
                    Green_Charges: gst.Green_Charges,
                    Hamali_Charges: gst.Hamali_Charges,
                    Other_Charges: gst.Other_Charges,
                    Insurance_Charges: gst.Insurance_Charges,
                    Subtotal: Subtotal,
                    CGSTPer: gst.CGSTPer,
                    CGSTAmt: gst.CGSTAmt,
                    SGSTPer: gst.SGSTPer,
                    SGSTAmt: gst.SGSTAmt,
                    IGSTPer: gst.IGSTPer,
                    IGSTAmt: gst.IGSTAmt,
                    TotalGST: gst.TotalGST,
                    TotalAmount: TotalAmount,
                }));

            } catch (error) {
                console.error("❌ Error in GST API:", error);
            }
        };

        if (
            formData.Vendor_Code &&
            formData.Mode_Code &&
            formData.VendorAmt && !skipGstCalc
        ) {
            calculateVenGstDetails();
        }
    }, [
        formData.Vendor_Code,
        formData.Mode_Code,
        formData.VendorAmt,
    ]);



    useEffect(() => {
        // 🔵 1) FETCH RATE → UPDATE VendorAmt → CALL GST
        const handleVenMakeRate = async () => {
            try {
                const body = {
                    Vendor_Code: formData.Vendor_Code,
                    Mode_Codes: formData.Mode_Code,
                    Origin_Code: formData.OriginCode,
                    Destination_Codes: formData.DestinationCode,
                    Zone_Codes: formData.Dest_Zone,
                    State_Codes: getCity.find(c => c.City_Code === formData.DestinationCode)?.State_Code || "27",
                    Weight: parseFloat(formData.VendorWt),
                    Method: "Credit",
                    Dox_Spx: formData.DoxSpx,
                };

                const res = await postApi("/Master/VendorRateCalculation", body);
                if (res.GetDataSuccess === 1 && res.Data.length > 0) {
                    let rateKg = Number(res?.Data?.[0]?.RatePerKg) || 0;
                    let amount = rateKg * Number(formData.VendorWt || 0);

                    // 1️⃣ Update both together to avoid stale data
                    setFormData(prev => ({
                        ...prev,
                        VendorRatePerkg: rateKg,
                        VendorAmt: amount
                    }));


                    // 2️⃣ Immediately calculate GST using fresh amount (not from state)

                }
                else {
                    setFormData(prev => ({
                        ...prev,
                        VendorRatePerkg: 0,
                    }));


                }

            } catch (err) {
                console.log("❌ Rate API Failed", err);


            }
        };

        // 
        if (formData.Vendor_Code && formData.Mode_Code && formData.Dest_Zone && formData.OriginCode && formData.VendorWt && !skipGstCalc) {
            handleVenMakeRate();
        }
    },
        [
            formData.Vendor_Code,
            formData.Mode_Code,
            formData.OriginCode,
            formData.DestinationCode,
            formData.Dest_Zone,
            formData.BookMode,
            formData.DoxSpx,
            formData.VendorWt]);

    useEffect(() => {



        const handleMakeRate = async () => {
            try {
                const body = {
                    Client_Code: formData.Customer_Code,
                    Vendor_Code: formData.Vendor_Code,
                    Mode_Codes: formData.Mode_Code,
                    Origin_Code: formData.OriginCode,
                    Destination_Codes: formData.DestinationCode,
                    Zone_Codes: formData.Dest_Zone,
                    State_Codes:
                        getDest.find(c => c.City_Code === formData.DestinationCode)?.State_Code,
                    Weight: Math.max(
                        parseFloat(formData.ActualWt) || 0,
                        parseFloat(formData.VolumetricWt) || 0,
                        parseFloat(formData.ChargedWt) || 0
                    )
                };

                const response = await postApi("/Master/GetCustomerRateCalculate", body);

                if (response?.Success === 1) {
                    const rateperKg = response.Data?.Rate || 0;
                    const rate = response.Data?.Final_Rate || 0;
                    const flag = response.Data?.Flag;

                    // ✅ use REF (instant)

                    if (flag === "Per Kg Rate") {
                        setFormData(prev => ({
                            ...prev,
                            RatePerkg: rateperKg,
                            Rate: rate,
                        }));
                    } else {
                        setFormData(prev => ({
                            ...prev,
                            RatePerkg: 0,
                            Rate: rate,
                        }));
                    }



                } else {


                    setGstData({
                        CGSTAMT: 0,
                        SGSTAMT: 0,
                        IGSTAMT: 0,
                        TotalGST: 0,
                        CGSTPer: 0,
                        SGSTPer: 0,
                        IGSTPer: 0,
                        GSTPer: 0,
                    });

                    setFormData((prev) => ({
                        ...prev,

                        FuelCharges: 0,
                        FuelPer: 0,

                        CGST: 0,
                        SGST: 0,
                        IGST: 0,

                        TotalGST: 0,
                        totalgstPer: 0,
                        Rate: 0,
                        RatePerkg: 0,
                        TotalAmt: 0,

                        FovChrgs: 0,
                        FovPer: 0,

                        DocketChrgs: 0,
                        DeliveryChrgs: 0,
                        PackingChrgs: 0,
                        GreenChrgs: 0,
                        HamaliChrgs: 0,
                        OtherCharges: 0,
                        InsuranceChrgs: 0,

                        // Custom Charges
                        charge1: 0,
                        charge2: 0,
                        charge3: 0,
                        charge4: 0,
                        charge5: 0,
                        charge6: 0,
                        charge7: 0,
                        charge8: 0,
                        charge9: 0,
                        charge10: 0,
                        charge11: 0,
                    }));
                }

            } catch (error) {
                console.error("❌ Error fetching rate:", error);

            }
        };

        if (
            formData.Customer_Code &&
            formData.Vendor_Code &&
            formData.Mode_Code &&
            formData.Dest_Zone &&
            formData.OriginCode &&
            !skipGstCalc && !skipRateCalcRef.current
        ) {
            handleMakeRate();
        }

    }, [
        formData.Customer_Code,
        formData.Vendor_Code,
        formData.Mode_Code,
        formData.OriginCode,
        formData.DestinationCode,
        formData.Dest_Zone,
        formData.ActualWt,
        formData.VolumetricWt,
        formData.ChargedWt
    ]);

    useEffect(() => {

        if (!formData.VendorAmt || formData.VendorAmt == 0 && !skipGstCalc) {
            setVendorShow({
                Rate: 0,
                Fuel_Charges: 0,
                Fuel_Per: 0,
                Fov_Charges: 0,
                Fov_Per: 0,
                Docket_Charges: 0,
                ODA_Charges: 0,
                Delivery_Charges: 0,
                Packing_Charges: 0,
                Green_Charges: 0,
                Hamali_Charges: 0,
                Other_Charges: 0,
                Insurance_Charges: 0,
                Subtotal: 0,
                CGSTPer: 0,
                CGSTAmt: 0,
                SGSTPer: 0,
                SGSTAmt: 0,
                IGSTPer: 0,
                IGSTAmt: 0,
                TotalGST: 0,
                TotalAmount: 0
            });
        }
    }, [formData.VendorAmt]);


    useEffect(() => {
        const calculateGstDetails = async () => {
            try {


                if (!formData.Customer_Code || !formData.Mode_Code || !formData.Rate || !formData.BookMode) return;

                // Build request body
                const body = {
                    Customer_Code: formData.Customer_Code,
                    Vendor_Code: formData.Vendor_Code,
                    Mode_Code: formData.Mode_Code,
                    Rate: String(formData.Rate),
                    Booking_Date: formData.BookDate,
                    // T_Flag: formData.BookMode,
                };
                const response = await postApi(`/Booking/calculateGST`, body);

                const gst = response.data;
                console.log("✅ GST API Response:", gst);
                console.log(`input==${gst?.Success}`);
                setGstData({
                    CGSTAMT: gst.CGSTAMT,
                    SGSTAMT: gst.SGSTAMT,
                    IGSTAMT: gst.IGSTAMT,
                    TotalGST: gst.TotalGST,
                    CGSTPer: gst.CGSTPer,
                    SGSTPer: gst.SGSTPer,
                    IGSTPer: gst.IGSTPer,
                    GSTPer: gst.CGSTPer + gst.SGSTPer + gst.IGSTPer,
                });

                // setIsGstCalculated(true);
                setFormData((prev) => ({
                    ...prev,
                    FuelCharges: gst.Fuel_Charges,
                    FuelPer: gst.Fuel_Per,
                    CGST: gst.CGSTAMT,
                    SGST: gst.SGSTAMT,
                    IGST: gst.IGSTAMT,
                    TotalGST: gst.TotalGST,
                    totalgstPer: gst.CGSTPer + gst.SGSTPer + gst.IGSTPer,
                    TotalAmt: gst.TotalAmt,
                    FovChrgs: gst.Fov_Charges,
                    FovPer: gst.Fov_Per || 0,
                    DocketChrgs: gst.Docket_Charges,
                    DeliveryChrgs: gst.Delivery_Charges,
                    PackingChrgs: gst.Packing_Charges,
                    GreenChrgs: gst.Green_Charges,
                    HamaliChrgs: gst.Hamali_Charges,
                    OtherCharges: gst.Other_Charges,
                    InsuranceChrgs: gst.Insurance_Charges,
                    // ✅ Custom Charges Mapping
                    charge1: gst.Security_Charges,
                    charge2: gst.Clearance_Charges,
                    charge3: gst.DGR_Charges,
                    charge4: gst.Risk_Charges,
                    charge5: gst.ADC_Charges,
                    charge6: gst.AWB_Charges,
                    charge7: gst.LargeSize_Charges,
                    charge8: gst.Transportation_Charges,
                    charge9: gst.Loading_Charges,
                    charge10: gst.Import_Duty_Charges,
                    charge11: 0, // ✅ fixed
                }));
            } catch (error) {
                console.error("❌ Error in GST API:", error);
            }
        };

        // Run only when essential fields change
        if (
            !skipGstCalc &&
            !skipRateCalcRef.current &&
            formData.Customer_Code &&
            formData.Mode_Code &&
            formData.Rate &&
            formData.BookDate
        ) {
            calculateGstDetails();
        }
    }, [
        formData.Customer_Code,
        formData.Mode_Code,
        formData.Rate,
        formData.BookMode,
        formData.Vendor_Code,
        formData.BookDate
    ]);
    useEffect(() => {

        const rate = Number(formData.Rate) || 0;

        if (!rate || skipGstCalc || skipRateCalcRef.current) return;

        // Charges
        const fuel = Number(formData.FuelCharges) || 0;
        const fov = Number(formData.FovChrgs) || 0;
        const docket = Number(formData.DocketChrgs) || 0;
        const oda = Number(formData.ODAChrgs) || 0;
        const delivery = Number(formData.DeliveryChrgs) || 0;
        const packing = Number(formData.PackingChrgs) || 0;
        const green = Number(formData.GreenChrgs) || 0;
        const hamali = Number(formData.HamaliChrgs) || 0;
        const other = Number(formData.OtherCharges) || 0;
        const insurance = Number(formData.InsuranceChrgs) || 0;

        // Extra Charges
        const charge1 = Number(formData.charge1) || 0;
        const charge2 = Number(formData.charge2) || 0;
        const charge3 = Number(formData.charge3) || 0;
        const charge4 = Number(formData.charge4) || 0;
        const charge5 = Number(formData.charge5) || 0;
        const charge6 = Number(formData.charge6) || 0;
        const charge7 = Number(formData.charge7) || 0;
        const charge8 = Number(formData.charge8) || 0;
        const charge9 = Number(formData.charge9) || 0;
        const charge10 = Number(formData.charge10) || 0;
        const charge11 = Number(formData.charge11) || 0;

        // GST %
        const CGSTPer = Number(gstData.CGSTPer) || 0;
        const SGSTPer = Number(gstData.SGSTPer) || 0;
        const IGSTPer = Number(gstData.IGSTPer) || 0;

        // Subtotal
        const subtotal =
            rate +
            fuel +
            fov +
            docket +
            oda +
            delivery +
            packing +
            green +
            hamali +
            other +
            insurance +

            // Extra Charges
            charge1 +
            charge2 +
            charge3 +
            charge4 +
            charge5 +
            charge6 +
            charge7 +
            charge8 +
            charge9 +
            charge10 +
            charge11;

        // GST Amounts
        const CGSTAMT = (subtotal * CGSTPer) / 100;
        const SGSTAMT = (subtotal * SGSTPer) / 100;
        const IGSTAMT = (subtotal * IGSTPer) / 100;

        const totalGST = CGSTAMT + SGSTAMT + IGSTAMT;

        const totalAmt = (subtotal + totalGST).toFixed(2);

        // Update GST State
        setGstData({
            CGSTPer,
            CGSTAMT,
            SGSTPer,
            SGSTAMT,
            IGSTPer,
            IGSTAMT,
            GSTPer: CGSTPer + SGSTPer + IGSTPer,
            TotalGST: totalGST
        });

        // Update FormData
        setFormData(prev => ({
            ...prev,
            Subtotal: subtotal,
            CGST: CGSTAMT,
            SGST: SGSTAMT,
            IGST: IGSTAMT,
            TotalGST: totalGST,
            TotalAmt: totalAmt
        }));

    }, [
        formData.Rate,
        formData.FuelCharges,
        formData.FovChrgs,
        formData.DocketChrgs,
        formData.ODAChrgs,
        formData.DeliveryChrgs,
        formData.PackingChrgs,
        formData.GreenChrgs,
        formData.HamaliChrgs,
        formData.OtherCharges,
        formData.InsuranceChrgs,

        // Extra Charges Dependencies
        formData.charge1,
        formData.charge2,
        formData.charge3,
        formData.charge4,
        formData.charge5,
        formData.charge6,
        formData.charge7,
        formData.charge8,
        formData.charge9,
        formData.charge10,
        formData.charge11
    ]);

    useEffect(() => {
        const getVolum = async (Customer_Code, Mode_Code) => {
            try {
                const response = await getApi(
                    `/Master/GetVolume?Customer_Code=${Customer_Code}&Mode_Code=${Mode_Code}`
                );
                if (response?.status === 1) {
                    const Data = response.data[0];
                    console.log('✅ Data:', Data);
                    setVolumetricData((prev) => ({
                        ...prev,
                        DivideBy: Number(Data.Centimeter),
                        cft: Number(Data.Feet),
                    }))

                }
                else {
                    setVolumetricData((prev) => ({
                        ...prev,
                        DivideBy: 0,
                    }))
                }
            } catch (error) {
                console.error("❌ Error in Volumetric:", error);
            }
        };
        if (formData.Customer_Code && formData.Mode_Code && !skipGstCalc) {
            getVolum(formData.Customer_Code, formData.Mode_Code);
        }
        else {
            setVolumetricData((prev) => ({
                ...prev,
                DivideBy: 0,
            }))
        }
    }, [formData.Customer_Code, formData.Mode_Code]);
    useEffect(() => {
        if (volumetricData.Length == 0 || volumetricData.Width == 0 || volumetricData.Height == 0 || volumetricData.Qty == 0 || volumetricData.DivideBy == 0) {
            setVolumetricData((prev) => (
                {
                    ...prev,
                    VolmetricWt: 0,
                }
            ))
            return;
        }
        if (volumetricData.Length && volumetricData.Width && volumetricData.Height && volumetricData.Qty && volumetricData.DivideBy) {
            console.log(volumetricData)
            let ans = 1;
            ans = ans * Number(volumetricData.Length);
            ans = ans * Number(volumetricData.Width);
            ans = ans * Number(volumetricData.Height);
            console.log(ans);
            if (volumetricData.cft) ans = ans * volumetricData.cft;
            console.log(ans);
            ans = ans / volumetricData.DivideBy;
            console.log(ans);
            ans = ans * Number(volumetricData.Qty);
            console.log(ans);
            setVolumetricData((prev) => (
                {
                    ...prev,
                    VolmetricWt: ans.toFixed(2),
                }
            ))
        }
        else {
            setVolumetricData((prev) => (
                {
                    ...prev,
                    VolmetricWt: 0,
                }
            ))
        }
    }, [volumetricData.Length, volumetricData.Width, volumetricData.Height, volumetricData.Qty, volumetricData.DivideBy])

    useEffect(() => {

        setFormData((pre) =>
        ({
            ...pre,
            ChargedWt: Math.max(formData.ActualWt || 0, formData.VolumetricWt || 0)

        }))
    }, [formData.ActualWt, formData.VolumetricWt])


    useEffect(() => {
        const getVolum = async (Vendor_Code, Mode_Code) => {
            try {
                const response = await getApi(
                    `Master/VendorVolumetric?Vondor_Code=${Vendor_Code}&Mode_Code=${Mode_Code}`
                );
                if (response?.status === 1) {
                    const Data = response.data[0];
                    console.log('✅ Data:', Data);
                    setVendorvolumetric((prev) => ({
                        ...prev,
                        DivideBy: Number(Data.Centimeter),
                        cft: Number(Data.Feet),
                    }))

                }
                else {
                    setVendorvolumetric((prev) => ({
                        ...prev,
                        DivideBy: 0,
                    }))
                }
            } catch (error) {
                console.error("❌ Error in Volumetric:", error);
            }
        };
        if (formData.Vendor_Code && formData.Mode_Code) {
            getVolum(formData.Vendor_Code, formData.Mode_Code);
        }
    }, [formData.Vendor_Code, formData.Mode_Code]);
    useEffect(() => {
        if (vendorVolumetric.Length == 0 || vendorVolumetric.Width == 0 || vendorVolumetric.Height == 0 || vendorVolumetric.Qty == 0 || vendorVolumetric.DivideBy == 0) {
            setVendorvolumetric((prev) => (
                {
                    ...prev,
                    VolmetricWt: 0,
                }
            ))
            return;
        }
        if (vendorVolumetric.Length && vendorVolumetric.Width && vendorVolumetric.Height && vendorVolumetric.Qty && vendorVolumetric.DivideBy) {
            console.log(vendorVolumetric)
            let ans = 1;
            ans = ans * Number(vendorVolumetric.Length);
            ans = ans * Number(vendorVolumetric.Width);
            ans = ans * Number(vendorVolumetric.Height);
            console.log(ans);
            if (vendorVolumetric.cft) ans = ans * vendorVolumetric.cft;
            console.log(ans);
            ans = ans / vendorVolumetric.DivideBy;
            console.log(ans);
            ans = ans * Number(vendorVolumetric.Qty);
            console.log(ans);
            setVendorvolumetric((prev) => (
                {
                    ...prev,
                    VolmetricWt: ans.toFixed(2),
                }
            ))
        }
        else {
            setVendorvolumetric((prev) => (
                {
                    ...prev,
                    VolmetricWt: 0,
                }
            ))
        }
    }, [vendorVolumetric.Length, vendorVolumetric.Width, vendorVolumetric.Height, vendorVolumetric.Qty, vendorVolumetric.DivideBy])



    useEffect(() => {
        if (!formData.VendorRatePerkg || formData.VendorRatePerkg == 0)
            return;
        const wt = parseFloat(formData.VendorWt) || 0;
        const ratePerKg = parseFloat(formData.VendorRatePerkg) || 0;
        const Amount = wt * ratePerKg;
        setFormData((prev) => ({
            ...prev,
            VendorAmt: Amount,
        }));


    }, [formData.VendorWt, formData.VendorRatePerkg]);

    useEffect(() => {
        const qty = parseFloat(PinvoiceData.Qty) || 0;
        const rate = parseFloat(PinvoiceData.UnitRate) || 0;
        const Amount = qty * rate;
        setPinvoiceData((prev) => ({
            ...prev,
            Amount: Amount,
        }));


    }, [PinvoiceData.Qty, PinvoiceData.UnitRate]);

    useEffect(() => {
        if (!selectedRateData) return;

        skipRateCalcRef.current = true;

        const gst = selectedRateData; // 👈 treat it like gst source

        // ================= FORM DATA =================
        setFormData(prev => ({
            ...prev,
            Customer_Code: gst?.Customer_Code,
            Branch_Code: gst?.Branch_Code,
            BookMode: gst?.Booking_Type,
            Vendor_Code: gst?.Vendor_Code,
            Mode_Code: gst?.Mode_Code,
            DestinationCode: gst?.City_Code,
            City_Name: gst?.City_Name,
            ConsigneeCountry: gst?.City_Name,
            ConsigneePin: gst?.DestinationPincode,
            Dest_Zone: gst?.Zone_Code,
            destZoneName: gst?.Zone_Name,
            OriginCode: gst?.OriginCity_Code,
            Origin_code: gst?.OriginCity_Name,
            Origin_Zone: gst?.OriginZone_Code,
            orgZoneName: gst?.OriginZone_Name,
            DoxSpx: gst?.Shipment_Type,
            Rate: gst?.Freight,
            RatePerkg: gst?.Flag === "Per Kg Rate" ? gst?.Rate_PerKg : 0,
            ActualWt: gst?.Input_Weight,

            // ===== CHARGES =====
            FuelCharges: gst?.Fuel_Charges,
            FuelPer: gst?.Fuel_Per,

            FovChrgs: gst?.Fov_Charges,
            FovPer: gst?.Fov_Per || 0,

            DocketChrgs: gst?.Docket_Charges,
            DeliveryChrgs: gst?.Dilivery_Charges || gst?.Delivery_Charges, // handle typo

            PackingChrgs: gst?.Packing_Charges,
            GreenChrgs: gst?.Green_Charges,
            HamaliChrgs: gst?.Hamali_Charges,
            OtherCharges: gst?.Other_Charges,
            InsuranceChrgs: gst?.Insurance_Charges,

            // Custom Charges
            charge1: gst?.Security_Charges,
            charge2: gst?.Clearance_Charges,
            charge3: gst?.DGR_Charges,
            charge4: gst?.Risk_Charges,
            charge5: gst?.ADC_Charges,
            charge6: gst?.AWB_Charges,
            charge7: gst?.LargeSize_Charges,
            charge8: gst?.Transportation_Charges,
            charge9: gst?.Loading_Unloading,
            charge10: gst?.Import_Duty_Charges,
            charge11: 0,

            CGST: gst?.CGST,
            SGST: gst?.SGST,
            IGST: gst?.IGST,
            TotalGST: gst?.Total_GST,
            totalgstPer: gst?.Total_GST_Per,
            TotalAmt: gst?.Grand_Total,
        }));

        // ================= GST STATE =================
        setGstData({
            CGSTAMT: gst?.CGST,
            SGSTAMT: gst?.SGST,
            IGSTAMT: gst?.IGST,
            TotalGST: gst?.Total_GST,
            CGSTPer: gst?.CGST_Per,
            SGSTPer: gst?.SGST_Per,
            IGSTPer: gst?.IGST_Per,
            GSTPer: gst?.Total_GST_Per,
        });

        setSelectedDestPinCode(gst?.DestinationPincode);
        setSelectedOriginPinCode(gst?.OriginPincode);

        setTimeout(() => {
            skipRateCalcRef.current = false;
        }, 1000);

        setSelectedRateData(null);

    }, [selectedRateData]);

    
    useEffect(() => {
        console.log(skipGstCalc, skipRateCalcRef.current);
        if (skipGstCalc || skipRateCalcRef.current) {
            return;
        }
        console.log("inter rate cal")

        const actual = parseFloat(formData.ActualWt) || 0;
        const volumetric = parseFloat(formData.VolumetricWt) || 0;
        const manualCharged = parseFloat(formData.ChargedWt) || 0;
        const ratePerKg = parseFloat(formData.RatePerkg) || 0;

        const highestWeight = Math.max(actual, volumetric, manualCharged);
        if (vendorsubmittedData.length === 0) {
            setFormData((prev) => ({
                ...prev,
                VendorWt: highestWeight,

            }));
        }

        const freightAmount = highestWeight * ratePerKg;

        if (freightAmount > 0) {
            const fuelPer = parseFloat(formData.FuelPer);
            if (fuelPer > 0) {
                const fuel = (freightAmount * fuelPer) / 100;
                setFormData((prev) => ({
                    ...prev,
                    FuelCharges: fuel.toFixed(2),
                }));
            }
            setFormData((prev) => ({
                ...prev,
                Rate: freightAmount.toFixed(2),

            }));
        }
        console.log("rate", freightAmount);
    }, [formData.ActualWt, formData.VolumetricWt, formData.ChargedWt, formData.RatePerkg]);

    

    useEffect(() => {
        console.log("Active:", toggleActive);
    }, [toggleActive])

    useEffect(() => {
        setVolumetricData((pre) =>
        ({
            ...pre,
            ChargeWt: Math.max(volumetricData.ActualWt || 0, volumetricData.VolmetricWt || 0)

        }))
    }, [volumetricData.ActualWt, volumetricData.VolmetricWt])

    useEffect(() => {
        setVendorvolumetric((pre) =>
        ({
            ...pre,
            ChargeWt: Math.max(vendorVolumetric.ActualWt || 0, vendorVolumetric.VolmetricWt || 0)

        }))
    }, [vendorVolumetric.ActualWt, vendorVolumetric.VolmetricWt])






    // ================================Rate+All Charges calculate=======================
    const resetAllForms = () => {
        console.log("reset");
        setFecthed(null);
        setFormData({
            ActualShipper: "",
            ActualWt: 0,
            Branch_Code: "",
            BillParty: "Client-wise Bill",
            BookDate: getTodayDate(),
            BookMode: "",
            ChargedWt: 0,
            ConsigneeAdd1: "",
            ConsigneeAdd2: "",
            ConsigneeGST: "",
            ConsigneePin: "",
            ConsigneeState: "",
            Consignee_City: "",
            ConsigneeEmail: "",
            ConsigneeMob: "",
            ConsigneeName: "",
            ConsigneeCountry: "",
            Customer_Code: "",
            charge1: 0,
            charge2: 0,
            charge3: 0,
            charge4: 0,
            charge5: 0,
            charge6: 0,
            charge7: 0,
            charge8: 0,
            charge9: 0,
            charge10: 0,
            charge11: 0,
            DeliveryChrgs: 0,
            Dest_Zone: "",
            DestinationCode: "",
            DocketChrgs: 0,
            DocketNo: "",
            DoxSpx: "Dox",
            RateType: "Credit",
            DispatchDate: getTodayDate(),
            EwayBill: "",
            ExptDateOfDelvDt: "",
            Flight_Code: "",
            FovChrgs: 0,
            FovPer: 0,
            FuelCharges: 0,
            FuelPer: 0,
            GreenChrgs: 0,
            HamaliChrgs: 0,
            InsuranceChrgs: 0,
            InvDate: getTodayDate(),
            InvValue: 0,
            InvoiceNo: "",
            SkycType: "",
            SkycNo: "",
            Location_Code: "",
            Mode_Code: "",
            method: "Credit",
            ODAChrgs: 0,
            OriginCode: "",
            Origin_Zone: "",
            OtherCharges: 0,
            PackingChrgs: 0,
            QtyOrderEntry: "",
            Rate: 0,
            RatePerkg: 0,
            RateType: "Weight",
            Receiver_Code: "",
            ShipperAdd: "",
            ShipperAdd2: "",
            ShipperAdd3: "",
            ShipperCity: "",
            ShipperEmail: "",
            ShipperPhone: "",
            ShipperPin: "",
            Shipper_GstNo: "",
            Shipper_Name: "",
            Shipper_StateCode: "",
            Status: "",
            TotalAmt: 0,
            TotalGST: 0,
            totalgstPer: 0,
            Train_Code: "",
            VendorRatePerkg: 0,
            VendorAmt: 0,
            VendorAwbNo: "",
            VendorWt: 0,
            Vendor_Code: "",
            VolumetricWt: 0,
            WebAgent: "",
            destZoneName: "",
            orgZoneName: ""
        });
        setInputValue('');
        setInputValue1('');
        setInputValue2('');
        setInputValue3('');


        setSelectedOriginPinCode('');
        setSelectedDestPinCode('');
        setSelectedModeName('');

        setVendorData({
            Vendor_Code1: "",
            Vendor_Code2: "",
            VendorAwbNo1: "",
            VendorAwbNo2: ""
        });

        setGstData({
            IGSTPer: 0,
            IGSTAMT: 0,
            CGSTPer: 0,
            CGSTAMT: 0,
            SGSTPer: 0,
            SGSTAMT: 0,
            TotalGST: 0,
            GSTPer: 0,
        });

        setRemarkData({
            Remark: "",
            MHWNo: "",
            invoiceType: "INVOICE",
            curr: "INR",
            inco: "DDU",
            note: "",
            noteCont: "",
        });

        setVendorvolumetric({
            Length: 0,
            Width: 0,
            Height: 0,
            Qty: 0,
            DivideBy: 0,
            cft: 0,
            VolmetricWt: 0,
            ActualWt: 0,
            ChargeWt: 0
        });

        setVolumetricData({
            Length: 0,
            Width: 0,
            Height: 0,
            Qty: 0,
            DivideBy: 0,
            cft: 0,
            VolmetricWt: 0,
            ActualWt: 0,
            ChargeWt: 0,
        });

        setInvoiceData({
            PoNo: "",
            PoDate: getTodayDate(),
            Currency: "INR",
            InvoiceNo: "",
            InvoiceValue: 0,
            Description: "",
            Qty: 0,
            EWayBillNo: "",
            EwayBillDate: getTodayDate(),
            Remark: "",
            InvoiceImg: ""
        });

        setPinvoiceData({
            InvoiceNo: PinvoicesubmittedData.length + 1,
            InvoiceValue: "",
            DocketNO: "",
            InvoiceDate: getTodayDate(),
            Remark1: "",
            Remark2: "",
            Remark3: "",
            Description: "",
            HSCode: "",
            UnitType: "",
            Qty: 0,
            UnitRate: 0,
            Amount: 0,
        })

        setSubmittedData([]);
        setInvoiceSubmittedData([]);
        setPinvoiceSubmittedData([]);
        setVendorSubmittedData([]);
    };

    const allVendorOption = getMode?.length > 0 ? getVendor.map(Vendr => ({ label: Vendr.Vendor_Name, value: Vendr.Vendor_Code })) : [];

    const allCustomerOptions =

        Array.isArray(getCustomerdata) && getCustomerdata.length > 0
            ? getCustomerdata
                .map(cust => ({
                    label: cust.Customer_Name,
                    value: cust.Customer_Code.toString(),
                    Booking_Type: cust.Booking_Type,
                    CustomerGst: cust.CustomerGst,
                    CustomerFuel: cust.CustomerFuel,
                    Branch_Code: cust.Branch_Code,
                }))
            : []
    function isNumberString(value) {
        return typeof value === "string" && /^\d+$/.test(value);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Step 1: Basic Validation Logic 
        const errors = [];
        // if (!formData.DocketNo) errors.push("DocketNo is required");
        if (!formData.BookDate) errors.push("Booking Date is required");
        if (!formData.Customer_Code) errors.push("Customer is required");
        if (!formData.ActualWt) errors.push("ActualWt is required");
        if (!formData.DestinationCode) errors.push("Destination_Name is required");
        if (!formData.Mode_Code) errors.push("Mode_Name is required");
        if (!formData.OriginCode) errors.push("Origin_Name is required");
        if (!formData.QtyOrderEntry || parseFloat(formData.QtyOrderEntry) <= 0) errors.push("Quantity must be greater than 0");
        // if (!formData.DoxSpx) errors.push("DoxSpx is required");
        // if (!formData.RateType) errors.push("RateType is required");

        // You can add more required validations here as needed...

        // Step 2: If errors, show and return early
        if (errors.length > 0) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                html: errors.map(err => `<div>${err}</div>`).join(''),
            });
            return;
        }

        let Receiver_Code = !isNumberString(formData.ConsigneeName) ? "" : formData.ConsigneeName;
        let Consignee_Name = !isNumberString(formData.ConsigneeName) ? formData.ConsigneeName : allReceiverOption.find(x => x.value === formData.ConsigneeName)?.label;
        let Shipper_Code = !isNumberString(formData.Shipper_Name) ? "" : formData.Shipper_Name;
        let Shipper_Name = !isNumberString(formData.Shipper_Name) ? formData.Shipper_Name : allShipperOption.find(x => x.value === formData.Shipper_Name)?.label;

        // Step 3: Continue if no errors
        const requestBody = {
            // BASIC
            Location_Code: formData.Branch_Code,
            DocketNo: formData.DocketNo,
            BookDate: formatDate(formData.BookDate),
            Customer_Code: formData.Customer_Code,
            BookMode: formData.BookMode,
            T_Flag: formData.BookMode,
            UserName: JSON.parse(localStorage.getItem("Login"))?.Employee_Name,

            // CONSIGNEE
            Receiver_Code: Receiver_Code,
            Consignee_Name: Consignee_Name,
            Consignee_Add1: formData.ConsigneeAdd1,
            Consignee_Add2: formData.ConsigneeAdd2,
            Consignee_State: formData.ConsigneeState,
            Consignee_Pin: formData.ConsigneePin,
            Consignee_City: formData.Consignee_City,
            Consignee_Mob: formData.ConsigneeMob,
            Consignee_Email: formData.ConsigneeEmail,
            Consignee_GST: formData.ConsigneeGST,
            Consignee_Country: formData.ConsigneeCountry,

            // SHIPPER
            Shipper_Code: Shipper_Code,
            Shipper_Name: Shipper_Name,
            ActualShipper: formData.ActualShipper,
            ShipperAdd: formData.ShipperAdd,
            ShipperAdd2: formData.ShipperAdd2,
            ShipperAdd3: formData.ShipperAdd3,
            ShipperCity: formData.ShipperCity,
            Shipper_StateCode: formData.Shipper_StateCode,
            Shipper_GstNo: formData.Shipper_GstNo,
            ShipperPin: formData.ShipperPin,
            ShipperPhone: formData.ShipperPhone,
            ShipperEmail: formData.ShipperEmail,

            // ROUTING + MODE
            Mode_Code: formData.Mode_Code,
            Origin_code: formData.OriginCode,
            Origin_Zone: formData.Origin_Zone,
            Origin_Pincode: selectedOriginPinCode,
            Destination_Code: formData.DestinationCode,
            Dest_Zone: formData.Dest_Zone,
            Dest_PinCode: selectedDestPinCode,
            DestName: formData.DestName,
            BillParty: formData.BillParty,

            // CHARGES
            Qty: formData.QtyOrderEntry,
            RateType: "",
            DoxSpx: formData.DoxSpx,
            DispatchDate: formatDate(formData.DispatchDate),
            Rate: formData.Rate,
            RatePerkg: formData.RatePerkg,
            ActualWt: formData.ActualWt,
            ChargedWt: formData.ChargedWt,
            VolumetricWt: formData.VolumetricWt,
            FuelPer: formData.FuelPer,
            FuelCharges: formData.FuelCharges,
            FovChrgs: formData.FovChrgs,
            DocketChrgs: formData.DocketChrgs,
            ODAChrgs: formData.ODAChrgs,
            DeliveryChrgs: formData.DeliveryChrgs,
            PackingChrgs: formData.PackingChrgs,
            GreenChrgs: formData.GreenChrgs,
            HamaliChrgs: formData.HamaliChrgs,
            OtherCharges: formData.OtherCharges,
            InsuranceChrgs: formData.InsuranceChrgs,

            // GST
            IGSTPer: gstData.IGSTPer,
            IGSTAMT: gstData.IGSTAMT,
            CGSTPer: gstData.CGSTPer,
            CGSTAMT: gstData.CGSTAMT,
            SGSTPer: gstData.SGSTPer,
            SGSTAMT: gstData.SGSTAMT,
            TotalAmt: formData.TotalAmt,

            // VENDOR
            Vendor_Code: formData.Vendor_Code,
            Vendor_Code1: vendorData.Vendor_Code1,
            Vendor_Code2: vendorData.Vendor_Code2,
            VendorWt: formData.VendorWt,
            VendorAmt: formData.VendorAmt,
            VendorAwbNo: formData.VendorAwbNo,
            VendorAwbNo1: vendorData.VendorAwbNo1,
            VendorAwbNo2: vendorData.VendorAwbNo2,

            // KYC / FLIGHT / TRAIN
            KYC_Type: formData.SkycType,
            KYC_No: formData.SkycNo,
            Flight_Code: formData.Flight_Code,
            Train_Code: formData.Train_Code,

            // INVOICE
            InvoiceNo: formData.InvoiceNo,
            InvValue: formData.InvValue,
            InvDate: formatDate(formData.InvDate),
            EwayBill: formData.EwayBill,
            Remark: remarkData.Remark,
            MHWNo: remarkData.MHWNo,

            // MULTIPLE JSON DATA
            MultiInvoice: InvoicesubmittedData,
            Volumetric: submittedData,
            Vendorvolumetric: vendorsubmittedData,
            ProformaDetail: PinvoicesubmittedData,

            Remark1: remarkData.inco,
            Remark2: remarkData.note,
            Remark3: remarkData.noteCont,
        };

        for (let i = 1; i <= 11; i++) {
            requestBody[`Charges${i}`] = JSON.stringify({
                label: label[`charge${i}`],     // 👈 from label state
                value: Number(formData[`charge${i}`]) || 0
            });
        }



        // Step 4: Submit
        try {
            const response = await postApi('/Booking/OderEntry', requestBody, 'POST');
            if (response.Success === 1) {
                setFecthed('');
                console.log(response);
                const generatedDocketNo = formData.DocketNo || response?.DocketNo;


                const FORMDATA = new FormData();
                FORMDATA.append("Ticket_No", generatedDocketNo);
                if (kyc1) FORMDATA.append("KYC1", kyc1);
                if (kyc2) FORMDATA.append("KYC2", kyc2);

                try {
                    const res = await postApi(
                        "/Booking/DocketWiseKycUpload",
                        FORMDATA,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        }
                    );
                    setKyc1(null);
                    setKyc2(null);

                    if (kyc1Ref.current) kyc1Ref.current.value = "";
                    if (kyc2Ref.current) kyc2Ref.current.value = "";

                } catch {
                    alert("Upload KYC failed ");
                }

                // Show confirmation popup
                const result = await Swal.fire({
                    title: `Docket Saved Successfully!: ${generatedDocketNo}`,
                    text: "Do you want to print the docket now?",
                    icon: 'success',
                    showCancelButton: true,
                    cancelButtonText: 'No, print',
                    reverseButtons: true,
                    confirmButtonText: 'Yes, print it!',
                });

                if (result.isConfirmed) {
                    try {
                        const response = await getApi(`/Booking/DocketReceipt?FromDocket=${generatedDocketNo}&ToDocket=${generatedDocketNo}&Branch_Code=${formData.Branch_Code}`);
                        if (response.status === 1) {
                            navigate("/MobileReceipt", { state: { data: response, path: location.pathname, tab: "vendor" } });
                        }
                        else {
                            Swal.fire("Warning", `Warong Docket Number`, "warning");
                        }
                    } catch (error) {
                        console.error("API Error:", error);
                    }
                }

                // ✅ Always reset after save (whether user confirms or not)
                const Customer_Code = formData.Customer_Code;
                const Vendor_Code = formData.Vendor_Code;
                const Branch_Code = formData.Branch_Code;
                const Origin_code = formData.OriginCode;
                const Pincode = selectedOriginPinCode;
                const zoneCode = formData.Origin_Zone;
                const zoneName = formData.orgZoneName;
                const bill = formData.BillParty;
                const book = formData.BookMode;
                const mode = formData.Mode_Code;

                resetAllForms();
                setFormData(prev => ({
                    ...prev,
                    Customer_Code: Customer_Code,
                    Branch_Code: Branch_Code,
                    OriginCode: Origin_code,
                    Origin_Zone: zoneCode,
                    orgZoneName: zoneName,
                    BillParty: bill,
                    BookMode: book,
                    Mode_Code: mode,
                    Vendor_Code: Vendor_Code
                }));
                setSelectedOriginPinCode(Pincode);
            }

        } catch (error) {
            console.error('Unable to save Booking Data:', error);
        }
    };



    const handleUpdate = async (e) => {
        e.preventDefault();
        const errors = [];
        // if (!formData.DocketNo) errors.push("DocketNo is required");
        if (!formData.BookDate) errors.push("Booking Date is required");
        if (!formData.Customer_Code) errors.push("Customer is required");
        if (!formData.ActualWt) errors.push("ActualWt is required");
        if (!formData.DestinationCode) errors.push("Destination_Name is required");
        if (!formData.Mode_Code) errors.push("Mode_Name is required");
        if (!formData.OriginCode) errors.push("Origin_Name is required");
        if (!formData.QtyOrderEntry || parseFloat(formData.QtyOrderEntry) <= 0) errors.push("Quantity must be greater than 0");
        // if (!formData.DoxSpx) errors.push("DoxSpx is required");
        // if (!formData.RateType) errors.push("RateType is required");

        // You can add more required validations here as needed...

        // Step 2: If errors, show and return early
        if (errors.length > 0) {
            Swal.fire({
                icon: 'error',
                title: 'Validation Error',
                html: errors.map(err => `<div>${err}</div>`).join(''),
            });
            return;
        }

        let Receiver_Code = !isNumberString(formData.ConsigneeName) ? "" : formData.ConsigneeName;
        let Consignee_Name = !isNumberString(formData.ConsigneeName) ? formData.ConsigneeName : allReceiverOption.find(x => x.value === formData.ConsigneeName)?.label;
        let Shipper_Code = !isNumberString(formData.Shipper_Name) ? "" : formData.Shipper_Name;
        let Shipper_Name = !isNumberString(formData.Shipper_Name) ? formData.Shipper_Name : allShipperOption.find(x => x.value === formData.Shipper_Name)?.label;


        const requestBody = {

            // BASIC
            Location_Code: formData.Branch_Code,
            DocketNo: formData.DocketNo,
            BookDate: formatDate(formData.BookDate),
            Customer_Code: formData.Customer_Code,
            BookMode: formData.BookMode,
            T_Flag: formData.BookMode,
            UserName: JSON.parse(localStorage.getItem("Login"))?.Employee_Name,

            // CONSIGNEE
            Receiver_Code: Receiver_Code,
            Consignee_Name: Consignee_Name,
            Consignee_Add1: formData.ConsigneeAdd1,
            Consignee_Add2: formData.ConsigneeAdd2,
            Consignee_State: formData.ConsigneeState,
            Consignee_Pin: formData.ConsigneePin,
            Consignee_City: formData.Consignee_City,
            Consignee_Mob: formData.ConsigneeMob,
            Consignee_Email: formData.ConsigneeEmail,
            Consignee_GST: formData.ConsigneeGST,
            Consignee_Country: formData.ConsigneeCountry,

            // SHIPPER
            Shipper_Code: Shipper_Code,
            Shipper_Name: Shipper_Name,
            ActualShipper: formData.ActualShipper,
            ShipperAdd: formData.ShipperAdd,
            ShipperAdd2: formData.ShipperAdd2,
            ShipperAdd3: formData.ShipperAdd3,
            ShipperCity: formData.ShipperCity,
            Shipper_StateCode: formData.Shipper_StateCode,
            Shipper_GstNo: formData.Shipper_GstNo,
            ShipperPin: formData.ShipperPin,
            ShipperPhone: formData.ShipperPhone,
            ShipperEmail: formData.ShipperEmail,

            // ROUTING + MODE
            Mode_Code: formData.Mode_Code,
            Origin_code: formData.OriginCode,
            Origin_Zone: formData.Origin_Zone,
            Origin_Pincode: selectedOriginPinCode,
            Destination_Code: formData.DestinationCode,
            Dest_Zone: formData.Dest_Zone,
            Dest_PinCode: selectedDestPinCode,
            DestName: formData.DestName,
            BillParty: formData.BillParty,

            // CHARGES
            Qty: formData.QtyOrderEntry,
            RateType: "",
            DoxSpx: formData.DoxSpx,
            DispatchDate: formatDate(formData.DispatchDate),
            Rate: formData.Rate,
            RatePerKg: formData.RatePerkg,
            ActualWt: formData.ActualWt,
            ChargedWt: formData.ChargedWt,
            VolumetricWt: formData.VolumetricWt,
            FuelPer: formData.FuelPer,
            FuelCharges: formData.FuelCharges,
            Fov_Chrgs: formData.FovChrgs,
            DocketChrgs: formData.DocketChrgs,
            ODA_Chrgs: formData.ODAChrgs,
            DeliveryChrgs: formData.DeliveryChrgs,
            PackingChrgs: formData.PackingChrgs,
            GreenChrgs: formData.GreenChrgs,
            HamaliChrgs: formData.HamaliChrgs,
            OtherCharges: formData.OtherCharges,
            InsuranceChrgs: formData.InsuranceChrgs,

            // ⭐ Add All (Charges1–Charges11) Here ⭐
            Charges1: formData.charge1,
            Charges2: formData.charge2,
            Charges3: formData.charge3,
            Charges4: formData.charge4,
            Charges5: formData.charge5,
            Charges6: formData.charge6,
            Charges7: formData.charge7,
            Charges8: formData.charge8,
            Charges9: formData.charge9,
            Charges10: formData.charge10,
            Charges11: formData.charge11,

            // GST
            IGSTPer: gstData.IGSTPer,
            IGSTAMT: gstData.IGSTAMT,
            CGSTPer: gstData.CGSTPer,
            CGSTAMT: gstData.CGSTAMT,
            SGSTPer: gstData.SGSTPer,
            SGSTAMT: gstData.SGSTAMT,
            TotalAmt: formData.TotalAmt,

            // VENDOR
            Vendor_Code: formData.Vendor_Code,
            Vendor_Code1: vendorData.Vendor_Code1,
            Vendor_Code2: vendorData.Vendor_Code2,
            VendorWt: formData.VendorWt,
            VendorAmt: formData.VendorAmt,
            VendorAwbNo: formData.VendorAwbNo,
            VendorAwbNo1: vendorData.VendorAwbNo1,
            VendorAwbNo2: vendorData.VendorAwbNo2,

            // KYC / FLIGHT / TRAIN
            KYC_Type: formData.SkycType,
            KYC_No: formData.SkycNo,
            Flight_Code: formData.Flight_Code,
            Train_Code: formData.Train_Code,

            // INVOICE
            InvoiceNo: formData.InvoiceNo,
            InvValue: formData.InvValue,
            InvDate: formatDate(formData.InvDate),
            EwayBill: formData.EwayBill,
            Remark: remarkData.Remark,
            MHWNo: remarkData.MHWNo,

            // MULTIPLE JSON DATA
            MultiInvoice: InvoicesubmittedData,
            Volumetric: submittedData,
            Vendorvolumetric: vendorsubmittedData,
            ProformaDetail: PinvoicesubmittedData,

            Remark1: remarkData.inco,
            Remark2: remarkData.note,
            Remark3: remarkData.noteCont,
        };
        for (let i = 1; i <= 11; i++) {
            requestBody[`Charges${i}`] = JSON.stringify({
                label: label[`charge${i}`],     // 👈 from label state
                value: Number(formData[`charge${i}`]) || 0
            });
        }
        try {
            const res = await postApi(`/Booking/OrderEntryUpdate`, requestBody);
            if (res.Success) {
                Swal.fire('Updated!', res.message || 'Booking updated.', 'success');
                // ✅ Always reset after save (whether user confirms or not)
                const Customer_Code = formData.Customer_Code;
                const Branch_Code = formData.Branch_Code;
                const Origin_code = formData.OriginCode;
                const Pincode = selectedOriginPinCode;
                const zoneCode = formData.Origin_Zone;
                const zoneName = formData.orgZoneName;
                const bill = formData.BillParty;
                const book = formData.BookMode;
                const mode = formData.Mode_Code;
                const Vendor_Code = formData.Vendor_Code;

                resetAllForms();
                setFormData(prev => ({
                    ...prev,
                    Customer_Code: Customer_Code,
                    Branch_Code: Branch_Code,
                    OriginCode: Origin_code,
                    Origin_Zone: zoneCode,
                    orgZoneName: zoneName,
                    BillParty: bill,
                    BookMode: book,
                    Mode_Code: mode,
                    Vendor_Code: Vendor_Code
                }));
                setSelectedOriginPinCode(Pincode);
                setFecthed('');
            } else Swal.fire('Error', res.message || 'Update failed.', 'error');
        } catch (err) {
            Swal.fire('Error', 'Something went wrong while updating.', 'error');
            console.log(err);
        }
    };





    const handleDelete = async (docketNo) => {
        if (!docketNo) return Swal.fire('Warning', 'Docket No is required', 'warning');

        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: `Delete booking with Docket No: ${docketNo}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            confirmButtonColor: '#d33'
        });

        if (confirm.isConfirmed) {
            try {
                const res = await postApi(`/Booking/deleteOrderByDocket?docketNo=${docketNo}`);
                if (res.Success) {
                    Swal.fire('Deleted!', res.message, 'success');
                    resetAllForms();
                } else {
                    Swal.fire('Error', res.message, 'error');
                }
            } catch (err) {
                Swal.fire('Error', 'Failed to delete booking.', 'error');
            }
        }
    };



    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    // const currentRows = getCustomerdata.slice(indexOfFirstRow, indexOfLastRow);
    // const totalPages = Math.ceil(getCustomerdata.length / rowsPerPage);











    const allFlightOptions = getFlight.map(f => ({
        value: f.Flight_Code,   // what you store
        label: f.Flight_Name, // visible in dropdown
        flightNo: f.Flight_No,  // extra info if needed
    }));

    const allTrainOptions = getTrain.map(t => ({
        value: t.Train_Code,   // what you store
        label: t.Train_Name, // visible in dropdown
        trainNo: t.Train_No,  // extra info if needed
    }));
    const allProductOptions = getProduct.map(p => ({
        value: p.Product_Name,   // what you store
        label: p.Product_Name, // visible in dropdown
        Code: p.Product_Code
    }));

    const unitTypeOptions = [
        { value: "Pkt", label: "Pkt" },
        { value: "Pc", label: "Pc" },
        { value: "PCS", label: "PCS" },
        { value: "Nos", label: "Nos" },
        { value: "Bottle", label: "Bottle" },
        { value: "Pair", label: "Pair" },
        { value: "Strip", label: "Strip" },
        { value: "Dozen", label: "Dozen" },
        { value: "Gross", label: "Gross" },
        { value: "Sets", label: "Sets" },
        { value: "Box", label: "Box" },
        { value: "KG", label: "KG" },
        { value: "Gram", label: "Gram" },
        { value: "Container", label: "Container" },
        { value: "Carats", label: "Carats" }
    ];


    const allModeOptions = getMode?.length > 0 ? getMode.map(mode => ({ label: mode.Mode_Name, value: mode.Mode_Code })) : [];
    const allCityOptions =
        getCity?.length > 0
            ? getCity.map(dest => ({
                label: dest.City_Name,
                value: dest.City_Code,
                pincode: dest.Pincode,
                zoneName: dest.Zone_Name,
                zoneCode: dest.Zone_Code,
            }))
            : [];

    const allDestOptions =
        getDest?.length > 0
            ? getDest.map(dest => ({
                label: dest.City_Name,
                value: dest.City_Code,
                pincode: dest.Pincode,
                zoneName: dest.Zone_Name,
                zoneCode: dest.Zone_Code,
                stateName: dest.State_Name,
                stateCode: dest.State_Code,
            }))
            : [];

    return (
        <>
            <style>
                {`
  .table td, th {
    padding: 3px !important;
  }
    .table td input{
    height:36px
    }
`}
            </style>

            <div className="body" style={{ margin: "0px", padding: "0px" }}>

                <div className="container1" style={{ padding: "0px", margin: "0px", paddingBottom: "0.8rem" }}>
                    <div className="container-2" style={{ border: "transparent", padding: "0px" }}>
                        <div className="left-card " style={{ margin: "0px" }} >


                            <form onSubmit={handleSubmit} onKeyDown={handleKeyDown} style={{ backgroundColor: "white" }}>
                                <div className="section-title">Customer Docket Information</div>

                                <div className="fields2" >
                                    <div className="input-field">
                                        <label htmlFor="shipper">Docket No</label>
                                        <input
                                            type="text"
                                            className={toggleActive ? "docket-input" : "docket-input disabled"}
                                            placeholder={toggleActive ? "Enter Docket No" : "Auto Booking On"}
                                            disabled={!toggleActive}
                                            value={formData.DocketNo}

                                            onKeyDown={(e) => {
                                                if (
                                                    toggleActive &&
                                                    (e.key === "Enter" || e.key === "Tab")
                                                ) {
                                                    handleSearch(e, formData.DocketNo, "manual");
                                                }
                                            }}

                                            onChange={async (e) => {
                                                const value = e.target.value;

                                                setFormData(prev => ({
                                                    ...prev,
                                                    DocketNo: value
                                                }));

                                                // call API after full docket entered

                                                try {

                                                    const res = await postApi(
                                                        "/Master/GetCustomerByDocketNo",
                                                        {
                                                            DocketNo: value,
                                                            Branch_Code: JSON.parse(localStorage.getItem("Login"))?.Branch_Code
                                                        }
                                                    );

                                                    if (res?.Status === 1) {

                                                        setFormData(prev => ({
                                                            ...prev,
                                                            BookMode: res?.BookingType || "",
                                                            Customer_Code: res?.CustomerCode || ""
                                                        }));

                                                    }

                                                } catch (error) {
                                                    console.log(error);
                                                }

                                            }}
                                        />
                                    </div>

                                    <div className="toggle-button">
                                        <Toggle
                                            checked={toggleActive}
                                            onChange={() => setToggleActive(prev => !prev)}
                                            tabIndex={-1}
                                        />


                                    </div>

                                    <div className="input-field">
                                        <label htmlFor="booking-date">Booking Date</label>
                                        <DatePicker
                                            selected={formData.BookDate}
                                            onChange={(date) => handleDateChange(date, "BookDate")}
                                            dateFormat="dd/MM/yyyy"
                                            className="form-control form-control-sm"
                                        />
                                    </div>
                                </div>

                                <div className="fields2" >
                                    <div style={{ display: "flex", flexDirection: "row", width: "98%" }}>


                                        <div className="input-field" style={{ width: "80%", position: "relative" }}>
                                            <label>Customer Name</label>
                                            <Select
                                                className="blue-selectbooking"
                                                classNamePrefix="blue-selectbooking"
                                                options={allCustomerOptions}
                                                value={
                                                    formData.Customer_Code ?
                                                        {
                                                            value: formData.Customer_Code,
                                                            label: allCustomerOptions.find(opt => opt.value === formData.Customer_Code)?.label
                                                        } || ""
                                                        : null
                                                }
                                                onChange={(selectedOption) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        Customer_Code: selectedOption.value,
                                                        Customer_Name: selectedOption.label,
                                                        Branch_Code: selectedOption.Branch_Code,
                                                        BookMode: selectedOption.Booking_Type,
                                                    }));
                                                }}
                                                placeholder="Select Customer"
                                                isSearchable
                                                menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll area
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps it above other UI
                                                }}
                                            />
                                        </div>
                                        <div className="input-field" style={{ width: "25%" }}>
                                            <label>Code</label>
                                            <input
                                                type="tel"
                                                placeholder="Code"
                                                value={formData.Customer_Code || ''}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>


                                <div className="container-fluid" style={{ paddingLeft: "1rem" }}>
                                    <div className="row g-2 align-items-end">
                                        {/* Shipper Name Input */}
                                        {isChecked2.Shipper_Details && <div className="col-md-10 col-sm-9 col-12">
                                            <div className="input-field">
                                                <label htmlFor="shipper">Shipper Name</label>
                                                <CreatableSelect
                                                    className="blue-selectbooking"
                                                    classNamePrefix="blue-selectbooking"
                                                    options={allShipperOption}
                                                    value={
                                                        formData.Shipper_Name
                                                            ? allShipperOption.find((opt) => opt.value === formData.Shipper_Name) ||
                                                            { value: formData.Shipper_Name, label: inputValue || formData.Shipper_Name }
                                                            : null
                                                    }
                                                    inputValue={inputValue}
                                                    onInputChange={(val, meta) => {
                                                        if (meta.action === "input-change") {
                                                            // ✅ Immediately reflect what user is typing
                                                            setInputValue(val);

                                                            // ✅ Also update formData live so label and value stay in sync
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                Shipper_Name: val,
                                                            }));
                                                        }
                                                    }}
                                                    onChange={handleShipperChange}
                                                    isClearable
                                                    isSearchable
                                                    formatCreateLabel={(inputValue) => `Create "${inputValue}"`}
                                                    placeholder="Select Shipper Name"
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    }}
                                                />

                                            </div>
                                        </div>}

                                        {/* Plus Button */}
                                        {isChecked2.Shipper_Details && <div className="col-md-2 col-sm-3 col-12">
                                            <label className="invisible">+</label>
                                            <button
                                                type="button"
                                                className="ok-btn btn btn-outline-primary w-100"
                                                onClick={() => {
                                                    setAddShipper({
                                                        shipperCode: '',
                                                        custCode: '',
                                                        shipperName: '',
                                                        shipperAdd1: '',
                                                        shipperAdd2: '',
                                                        shipperPin: '',
                                                        cityCode: '',
                                                        stateCode: '',
                                                        shipperMob: '',
                                                        shipperEmail: '',
                                                        gstNo: '',
                                                        company: '',
                                                    });
                                                    setModalIsOpen(true);
                                                }}
                                            >
                                                <i className="bi bi-plus" style={{ fontSize: "20px" }}></i>
                                            </button>
                                        </div>}
                                    </div>
                                </div>

                                <div className="fields2">
                                    {isChecked2.Shipper_Details && <>
                                        <div className="input-field">
                                            <label htmlFor="shipper-address">Shipper Address</label>
                                            <input
                                                type="text"
                                                id="shipper-address"
                                                placeholder="Shipper Address"
                                                value={formData.ShipperAdd}
                                                onChange={(e) => setFormData({ ...formData, ShipperAdd: e.target.value })}
                                                className="form-control custom-input"
                                            />
                                        </div>

                                        <div className="input-field">
                                            <label htmlFor="shipper-address">Shipper Address</label>
                                            <input
                                                type="text"
                                                id="shipper-address"
                                                placeholder="Shipper Address"
                                                value={formData.ShipperAdd2}
                                                onChange={(e) => setFormData({ ...formData, ShipperAdd2: e.target.value })}
                                                className="form-control custom-input"
                                            />
                                        </div>

                                        <div className="input-field">
                                            <label>City Name</label>
                                            <input
                                                type="text"
                                                placeholder="City"

                                                value={formData.ShipperAdd3}
                                                className="form-control custom-input"
                                                onChange={(e) => setFormData({ ...formData, ShipperAdd3: e.target.value })}

                                            />
                                        </div>
                                        <div className="input-field">
                                            <label htmlFor="">State Name</label>
                                            <Select
                                                className="blue-selectbooking"
                                                classNamePrefix="blue-selectbooking"
                                                options={getState.map((st) => ({
                                                    value: st.State_Code,
                                                    label: st.State_Name,
                                                }))}
                                                value={
                                                    formData.Shipper_StateCode
                                                        ? {
                                                            value: formData.Shipper_StateCode,
                                                            label:
                                                                getState.find((s) => s.State_Code === formData.Shipper_StateCode)
                                                                    ?.State_Name || "",
                                                        }
                                                        : null
                                                }
                                                onChange={(selected) =>
                                                    setFormData({
                                                        ...formData,
                                                        Shipper_StateCode: selected ? selected.value : "",
                                                    })
                                                }
                                                placeholder="Select State"
                                                isSearchable={true}
                                                isClearable={false}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                            />

                                        </div>

                                        <div className="input-field1">
                                            <label htmlFor="">Shipper Mobile No</label>
                                            <input
                                                type="tel"
                                                placeholder="Shipper Mobile No"
                                                maxLength={10}
                                                value={formData.ShipperPhone}
                                                onChange={(e) => setFormData({ ...formData, ShipperPhone: e.target.value })}
                                            />
                                        </div>

                                        <div className="input-field1">
                                            <label htmlFor="">Post / Zip Code</label>
                                            <input
                                                type="text"
                                                placeholder="Post / Zip Code"
                                                maxLength={9}
                                                pattern="[0-9]{8}"
                                                value={formData.ShipperPin}
                                                onChange={(e) => setFormData({ ...formData, ShipperPin: e.target.value })}
                                            />
                                        </div>


                                    </>}
                                    <div className="input-field1">
                                        <label htmlFor="">Booking Mode</label>
                                        {
                                            formData.Customer_Code ?
                                                <input value={formData.BookMode} onChange={(e) => setFormData({ ...formData, BookMode: e.target.value })}
                                                    readOnly />
                                                :


                                                <select value={formData.BookMode} onChange={(e) => setFormData({ ...formData, BookMode: e.target.value })}
                                                    readOnly>
                                                    <option value="" disabled>Select Booking Mode</option>
                                                    <option value="Cash">Cash</option>
                                                    <option value="Credit">Credit</option>
                                                    <option value="To-pay">To-pay</option>
                                                    <option value="Google Pay">Google Pay</option>
                                                    <option value="RTGS">RTGS</option>
                                                    <option value="NEFT">NEFT</option>
                                                </select>
                                        }
                                    </div>
                                    {isChecked2.ShipperkycDetails && <>
                                        <div className="input-field">
                                            <label>KYC Type</label>

                                            <Select
                                                className="blue-selectbooking"
                                                classNamePrefix="blue-selectbooking"
                                                options={getKyc.map(kyc => ({
                                                    value: kyc.KYC_Code,
                                                    label: kyc.KYC_Name
                                                }))}
                                                value={
                                                    formData.SkycType
                                                        ? {
                                                            value: formData.SkycType,
                                                            label: getKyc.find(kyc => kyc.KYC_Code === formData.SkycType)?.KYC_Name || ""
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        SkycType: selectedOption.value
                                                    }));
                                                }}
                                                placeholder="Select KYC Type"
                                                isSearchable
                                                menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll area
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps it above other UI
                                                }}
                                            />
                                        </div>

                                        <div className="input-field">
                                            <label htmlFor="kyc-no">KYC No</label>
                                            <input
                                                type="text"
                                                id="shipper-adhaar"
                                                placeholder="KYC No"
                                                value={formData.SkycNo}
                                                onChange={(e) => setFormData({ ...formData, SkycNo: e.target.value })}
                                                className="form-control custom-input"
                                            />
                                        </div>
                                        <img src={formData.uploadkyc1} alt="" />

                                        <div className="input-field" >
                                            <label htmlFor="upload-kyc">Upload KYC</label>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                <input
                                                    id="upload-kyc"
                                                    className="form-control custom-input"
                                                    style={{
                                                        paddingTop: "8px",
                                                        width: "85%",
                                                        borderRight: "none",
                                                        borderRadius: "4px 0 0 4px",

                                                    }}
                                                    ref={kyc1Ref}
                                                    type="file"
                                                    accept=".jpg,.jpeg,.png"
                                                    onChange={(e) => handleFileChange(e, setKyc1)}
                                                />

                                                <div style={{
                                                    width: "15%",
                                                    border: "1px solid  #4FD1C5",
                                                    borderLeft: "none",
                                                    borderRadius: "0 4px 4px 0",
                                                    padding: "5px",
                                                    textAlign: "center",
                                                    cursor: "pointer"
                                                }}
                                                    onClick={handleDownload}>


                                                    <FcDownload size={24} />



                                                </div>


                                            </div>



                                        </div>

                                        <div className="input-field" >
                                            <label htmlFor="upload-kyc">Upload KYC</label>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                <input

                                                    id="upload-kyc"
                                                    className="form-control custom-input"
                                                    style={{
                                                        paddingTop: "8px",
                                                        width: "85%",
                                                        borderRight: "none",
                                                        borderRadius: "4px 0 0 4px",

                                                    }}
                                                    ref={kyc2Ref}
                                                    type="file"
                                                    accept=".jpg,.jpeg,.png"
                                                    onChange={(e) => handleFileChange(e, setKyc2)}
                                                />

                                                <div style={{
                                                    width: "15%",
                                                    border: "1px solid  #4FD1C5",
                                                    borderLeft: "none",
                                                    borderRadius: "0 4px 4px 0",
                                                    padding: "5px",
                                                    textAlign: "center",
                                                    cursor: "pointer"
                                                }}
                                                    onClick={handleDownload2}>


                                                    <FcDownload size={24} />



                                                </div>


                                            </div>



                                        </div>

                                    </>}

                                    <div className="fields2" style={{ width: "100%", whiteSpace: "nowrap", paddingRight: "0.5rem" }}>
                                        <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px" }}>
                                            <div className="input-field" style={{ flex: "5", position: "relative" }}>
                                                <label>Mode Name</label>

                                                <Select
                                                    className="blue-selectbooking"
                                                    classNamePrefix="blue-selectbooking"
                                                    options={allModeOptions}
                                                    value={
                                                        formData.Mode_Code
                                                            ? allModeOptions.find(opt => opt.value === formData.Mode_Code)
                                                            : null
                                                    }
                                                    onChange={(selectedOption) => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            Mode_Code: selectedOption.value
                                                        }));
                                                    }}
                                                    placeholder="Select Mode Name"
                                                    isSearchable
                                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll area
                                                    styles={{
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps it above other UI
                                                    }}
                                                />
                                            </div>
                                            <div className="input-field" style={{ flex: "2" }}>
                                                <label>Code</label>
                                                <input
                                                    type="tel"
                                                    placeholder="Code"
                                                    value={formData.Mode_Code || ''}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px" }}>
                                            <div className="input-field" style={{ flex: "5", position: "relative" }}>
                                                <label>Vendor Name</label>
                                                <Select
                                                    className="blue-selectbooking"
                                                    classNamePrefix="blue-selectbooking"
                                                    options={allVendorOption}
                                                    value={
                                                        formData.Vendor_Code
                                                            ? allVendorOption.find(opt => opt.value === formData.Vendor_Code)
                                                            : null
                                                    }
                                                    onChange={(selectedOption) => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            Vendor_Code: selectedOption.value,
                                                            Vendor_Name: selectedOption.label
                                                        }));
                                                    }}
                                                    placeholder="Select Vendor Name"
                                                    isSearchable
                                                    menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll area
                                                    styles={{
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps it above other UI
                                                    }}
                                                />

                                            </div>
                                            <div className="input-field" style={{ flex: "2" }}>
                                                <label>Code</label>
                                                <input
                                                    type="tel"
                                                    placeholder="Code"
                                                    value={formData.Vendor_Code || ''}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Origin Row */}
                                    <div style={{ whiteSpace: "nowrap", display: "flex", marginBottom: "1rem", width: "100%", gap: "2px" }}>
                                        <div className="input-field1" style={{ width: "25%" }}>
                                            <label>Pincode</label>
                                            <input
                                                type="tel"
                                                placeholder="Pin Code"
                                                value={selectedOriginPinCode}
                                                onChange={handleOriginPinCodeChange}
                                                maxLength={6}
                                                pattern="[0-9]{6}"
                                            />
                                        </div>

                                        <div className="input-field1" style={{ width: "40%" }}>
                                            <label>Origin Name</label>
                                            <Select
                                                className="blue-selectbooking"
                                                classNamePrefix="blue-selectbooking"
                                                options={allCityOptions}
                                                value={formData.OriginCode ? { value: formData.OriginCode, label: allCityOptions.find(opt => opt.value === formData.OriginCode)?.label || "" } : null}
                                                onChange={(selected) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        OriginCode: selected.value,
                                                        Origin_code: selected.label,
                                                        Origin_Zone: selected.zoneCode,
                                                        orgZoneName: selected.zoneName

                                                    }));
                                                    setSelectedOriginPinCode(selected?.pincode);
                                                }}
                                                placeholder="Select Origin Name"
                                                isSearchable
                                                menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll area
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps it above other UI
                                                }}
                                            />
                                        </div>

                                        <div className="input-field1" style={{ width: "25%" }}>
                                            <label style={{}}>Origin Zone</label>
                                            <input type="text" placeholder="Zone_Name" value={formData.orgZoneName} readOnly />
                                        </div>
                                    </div>

                                    {/* Destination Row */}
                                    <div style={{ whiteSpace: "nowrap", display: "flex", marginBottom: "1rem", width: "100%", gap: "2px" }}>
                                        <div className="input-field1" style={{ width: "25%" }}>
                                            <label>Pincode</label>
                                            <input
                                                type="tel"
                                                placeholder="Pin Code"
                                                value={selectedDestPinCode}
                                                onChange={handleDestPinCodeChange}
                                                maxLength={6}
                                                pattern="[0-9]{6}"
                                            />
                                        </div>

                                        <div className="input-field1" style={{ width: "40%" }}>
                                            <label>Destination Name</label>
                                            <Select
                                                className="blue-selectbooking"
                                                classNamePrefix="blue-selectbooking"
                                                options={allDestOptions}
                                                value={
                                                    formData.DestinationCode

                                                        ? { value: formData.DestinationCode, label: allDestOptions.find(opt => opt.value === formData.DestinationCode)?.label || "" }
                                                        : null
                                                }
                                                onChange={(selected) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        DestinationCode: selected.value,
                                                        City_Name: selected.label,
                                                        Dest_Zone: selected.zoneCode,
                                                        destZoneName: selected.zoneName,
                                                        ConsigneeState: selected.stateName,
                                                        ConsigneeCountry: selected.label,
                                                    }));
                                                    setSelectedDestPinCode(selected?.pincode);
                                                }}
                                                placeholder="Select Destination"
                                                isSearchable
                                                menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                                }}
                                            />
                                        </div>

                                        <div className="input-field1" style={{ width: "25%" }}>
                                            <label>Dest Zone</label>
                                            <input
                                                type="text"
                                                placeholder="Zone_Name"
                                                value={formData.destZoneName}
                                                readOnly
                                            />
                                        </div>
                                    </div>


                                    <div className="card border p-1 mx-0" style={{ overflowX: "hidden", width: "100%" }}>
                                        <div className="section-title">Vendor Information</div>


                                        {isChecked2.Vendor_Details && <><div className="fields2" style={{ whiteSpace: "nowrap", paddingRight: "0.5rem" }}>

                                        </div>
                                            <div className="fields2" style={{ whiteSpace: "nowrap", paddingRight: "0.5rem" }}>
                                                <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px" }}>
                                                    <div className="input-field" style={{ flex: "5", position: "relative" }}>
                                                        <label className="form-label">Vendor Docket No</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Vendor Docket No"
                                                            value={formData.VendorAwbNo}
                                                            onChange={(e) =>
                                                                setFormData({ ...formData, VendorAwbNo: e.target.value })
                                                            }
                                                        />
                                                    </div>

                                                    <div className="input-field" style={{ flex: "2" }}>
                                                        <label>&nbsp;</label>
                                                        <button
                                                            type="button"
                                                            className="ok-btn"
                                                            onClick={() => setModalIsOpen5(true)}
                                                            style={{ height: "35px", width: "100%", color: "black" }}
                                                        >
                                                            <i className="bi bi-calculator" style={{ fontSize: "20px" }}></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="fields2" style={{ whiteSpace: "nowrap", paddingRight: "0.5rem" }}>
                                                <div className="input-field1">
                                                    <label className="form-label">Vendor Weight</label>
                                                    <input
                                                        type="tel"
                                                        className="form-control"
                                                        placeholder="V_Weight"
                                                        value={formData.VendorWt}
                                                        onChange={(e) => setFormData({ ...formData, VendorWt: e.target.value })}
                                                    />
                                                </div>

                                                <div className="input-field3">
                                                    <label className="form-label">Rate Per Kg</label>
                                                    <input
                                                        type="tel"
                                                        placeholder="Rate Per Kg"
                                                        value={formData.VendorRatePerkg}
                                                        onChange={(e) => setFormData({ ...formData, VendorRatePerkg: e.target.value })}
                                                    />
                                                </div>

                                                <div className="input-field1">
                                                    <label className="form-label">Vendor Amount</label>
                                                    <input
                                                        type="tel"
                                                        className="form-control"
                                                        placeholder="Vendor Amount"
                                                        value={formData.VendorAmt}
                                                        readOnly
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, VendorAmt: e.target.value })
                                                        }
                                                    />
                                                </div>

                                                <div className="input-field2">
                                                    <label className="form-label">&nbsp;</label>
                                                    <button
                                                        type="button"
                                                        className="ok-btn"
                                                        onClick={() => setModalIsOpen8(true)}
                                                        style={{ height: "35px", width: "100%", }}
                                                    >
                                                        <i className="bi bi-cash-coin" style={{ fontSize: "24px" }}></i>
                                                    </button>
                                                </div>






                                            </div></>}


                                        {isChecked2.Flight_Name && <div className="fields2" style={{ whiteSpace: "nowrap", paddingRight: "0.5rem" }}>
                                            <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px" }}>
                                                <div className="input-field" style={{ flex: "5", position: "relative" }}>
                                                    <label>Flight Name</label>

                                                    <Select
                                                        className="blue-selectbooking"
                                                        classNamePrefix="blue-selectbooking"
                                                        options={allFlightOptions}
                                                        value={
                                                            formData.Flight_Code
                                                                ? allFlightOptions.find(opt => opt.value === formData.Flight_Code)
                                                                : null
                                                        }
                                                        onChange={(selectedOption) => {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                Flight_Code: selectedOption.value,
                                                            }));
                                                        }}
                                                        placeholder="Select Flight Name"
                                                        isSearchable
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            menuPortal: base => ({ ...base, zIndex: 9999 })
                                                        }}
                                                    />

                                                </div>
                                                <div className="input-field" style={{ flex: "2" }}>
                                                    <label>Code</label>
                                                    <input
                                                        type="tel"
                                                        placeholder="Code"
                                                        value={formData.Flight_Code || ''}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                        </div>}

                                        {isChecked2.Train_Name && <div className="fields2" style={{ whiteSpace: "nowrap", paddingRight: "0.5rem" }}>
                                            <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px" }}>
                                                <div className="input-field" style={{ flex: "5", position: "relative" }}>
                                                    <label>Train Name</label>

                                                    <Select
                                                        className="blue-selectbooking"
                                                        classNamePrefix="blue-selectbooking"
                                                        options={allTrainOptions}
                                                        value={
                                                            formData.Train_Code
                                                                ? allTrainOptions.find(opt => opt.value === formData.Train_Code)
                                                                : null
                                                        }
                                                        onChange={(selectedOption) => {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                Train_Code: selectedOption.value,
                                                            }));
                                                        }}
                                                        placeholder="Select Train Name"
                                                        isSearchable
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            menuPortal: base => ({ ...base, zIndex: 9999 })
                                                        }}
                                                    />

                                                </div>
                                                <div className="input-field" style={{ flex: "2" }}>
                                                    <label>Code</label>
                                                    <input
                                                        type="tel"
                                                        placeholder="Code"
                                                        value={formData.Train_Code || ''}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                        </div>}


                                    </div>

                                </div>
                            </form>




                        </div>



                        <div className="right-card" style={{ margin: "0px" }}>
                            <div className="section-title">Consignee Docket Information</div>
                            <form
                                onSubmit={handleSaveReceiverFromBooking}
                                style={{ padding: 0, margin: 0, backgroundColor: "white" }}
                                onKeyDown={handleKeyDown}
                            >
                                {/* Receiver Name Row */}
                                {isChecked2.Consignee_Details && <div className="container-fluid mb-2">
                                    <div className="row g-2 align-items-end">
                                        <div className="col-md-10 col-sm-9 col-12">
                                            <div className="input-field mt-2" style={{ width: "100%", position: "relative" }}>
                                                <label>Consignee Name</label>
                                                <CreatableSelect
                                                    className="blue-selectbooking"
                                                    classNamePrefix="blue-selectbooking"
                                                    options={allReceiverOption}
                                                    value={
                                                        formData.ConsigneeName
                                                            ? allReceiverOption.find((opt) => opt.value === formData.ConsigneeName) ||
                                                            { value: formData.ConsigneeName, label: inputValue1 || formData.ConsigneeName }
                                                            : null
                                                    }
                                                    onChange={(selectedOption) => {
                                                        setInputValue1("");
                                                        if (selectedOption) {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                ConsigneeName: selectedOption.value,
                                                                Consignee_City: selectedOption.City_Code,
                                                                ConsigneeState: selectedOption.State_Name,
                                                                ConsigneePin: selectedOption.Receiver_Pin,
                                                                ConsigneeMob: selectedOption.Receiver_Mob,
                                                                ConsigneeEmail: selectedOption.Receiver_Email,
                                                                ConsigneeAdd1: selectedOption.Receiver_Add1,
                                                                ConsigneeAdd2: selectedOption.Receiver_Add2,
                                                                ConsigneeGST: selectedOption.GSTNo,
                                                                ConsigneeCountry: selectedOption.City_Name
                                                            }));
                                                        }
                                                        else {
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                ConsigneeName: "",
                                                            }));
                                                        }
                                                        // setSelectedOriginPinCode(selectedOption.Receiver_Pin)
                                                    }}
                                                    inputValue={inputValue1}
                                                    onInputChange={(val, meta) => {
                                                        if (meta.action === "input-change") {
                                                            // ✅ Immediately reflect what user is typing
                                                            setInputValue1(val);
                                                            // ✅ Also update formData live so label and value stay in sync
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                ConsigneeName: val,
                                                            }));
                                                        }
                                                    }}
                                                    isClearable
                                                    isSearchable
                                                    formatCreateLabel={(inputValue1) => `Create "${inputValue1}"`}
                                                    placeholder="Select Consignee Name"
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    }}
                                                />

                                            </div>
                                        </div>
                                        <div className="col-md-2 col-sm-3 col-12">
                                            <label className="invisible">+</label>
                                            <button
                                                type="button"
                                                className="ok-btn btn btn-outline-primary w-100"
                                                onClick={() => {
                                                    setModalIsOpen1(true);
                                                    setAddReceiver({
                                                        receiverCode: '',
                                                        receiverName: '',
                                                        receiverAdd1: '',
                                                        receiverAdd2: '',
                                                        receiverPin: '',
                                                        cityCode: '',
                                                        stateCode: '',
                                                        receiverMob: '',
                                                        receiverEmail: '',
                                                        gstNo: '',
                                                        hsnNo: '',
                                                        sms: false,
                                                        emailId: false,
                                                        whatsApp: false
                                                    });
                                                }}
                                            >
                                                <i className="bi bi-plus" style={{ fontSize: "20px" }}></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>}

                                {/* Other Receiver Fields */}
                                <div className="fields2">
                                    {isChecked2?.Consignee_Details && <>


                                        <div className="input-field">
                                            <label>Consignee Address</label>
                                            <input
                                                type="text"
                                                placeholder="Consignee Address"
                                                value={formData.ConsigneeAdd1}
                                                onChange={(e) => setFormData({ ...formData, ConsigneeAdd1: e.target.value })}
                                            />
                                        </div>

                                        <div className="input-field">
                                            <label>Consignee Address2</label>
                                            <input
                                                type="text"
                                                placeholder="Consignee Address2"
                                                value={formData.ConsigneeAdd2}
                                                onChange={(e) => setFormData({ ...formData, ConsigneeAdd2: e.target.value })}
                                            />
                                        </div>



                                        <div className="input-field1">
                                            <label>Mobile No</label>
                                            <input
                                                type="tel"
                                                placeholder="Mobile No"
                                                maxLength={15}
                                                value={formData.ConsigneeMob}
                                                onChange={(e) => setFormData({ ...formData, ConsigneeMob: e.target.value })}
                                            />
                                        </div>

                                        <div className="input-field1">
                                            <label>Email ID</label>
                                            <div>
                                                <input
                                                    type="email"
                                                    placeholder="Email ID"
                                                    value={formData.ConsigneeEmail}
                                                    onChange={(e) => setFormData({ ...formData, ConsigneeEmail: e.target.value })}
                                                    style={{ flex: 1 }}
                                                />
                                            </div>
                                        </div>


                                        <div className="input-field1">
                                            <label>GST No</label>
                                            <input
                                                type="text"
                                                placeholder="GST No"
                                                value={formData.ConsigneeGST}
                                                onChange={(e) => setFormData({ ...formData, ConsigneeGST: e.target.value })}
                                            />
                                        </div>


                                        <div className="input-field">
                                            <label htmlFor="">State Name</label>
                                            <input
                                                type="text"
                                                placeholder="State"
                                                value={formData.ConsigneeState}
                                                onChange={(e) => setFormData({ ...formData, ConsigneeState: e.target.value })}
                                            />


                                        </div>

                                        <div className="input-field">
                                            <label>City Name</label>
                                            <input
                                                type="text"
                                                placeholder="City"
                                                value={formData.ConsigneeCountry}
                                                onChange={(e) => setFormData({ ...formData, ConsigneeCountry: e.target.value })}
                                            />
                                        </div>

                                        <div className="input-field1">
                                            <label>Post / Zip Code</label>
                                            <input
                                                type="text"
                                                placeholder="Post / Zip Code"
                                                value={formData.ConsigneePin}
                                                maxLength={9}
                                                pattern="[0-9]{8}"
                                                onChange={(e) => setFormData({ ...formData, ConsigneePin: e.target.value })}
                                            />
                                        </div>


                                    </>}
                                    <div className="input-field3" style={{ marginTop: "23px" }}>
                                        <button className="btn btn-success" style={{}}>Save</button>
                                    </div>


                                </div>
                                <div className="fields2">
                                    {/* Conditional Sections */}
                                    {isChecked2.Invoice_Value && (
                                        <>
                                            <div className="input-field1">
                                                <label>Invoice Details</label>
                                                <button
                                                    type="button"
                                                    onClick={() => setModalIsOpen6(true)}
                                                    className="ok-btn w-100"
                                                    style={{ color: "black" }}
                                                >
                                                    <i className="bi bi-receipt-cutoff"></i>
                                                </button>
                                            </div>
                                            {isChecked2.Invoice_No && (
                                                <div className="input-field1">
                                                    <label>Invoice No</label>
                                                    <input
                                                        type="text"
                                                        placeholder="Invoice No"
                                                        value={formData.InvoiceNo}
                                                        onChange={(e) => setFormData({ ...formData, InvoiceNo: e.target.value })}
                                                    />
                                                </div>
                                            )}
                                            <div className="input-field1">
                                                <label>Invoice Value</label>
                                                <input
                                                    type="text"
                                                    placeholder="Invoice Value"
                                                    value={formData.InvValue}
                                                    onChange={(e) => setFormData({ ...formData, InvValue: e.target.value })}
                                                />
                                            </div>
                                            <div className="input-field1">
                                                <label>Performa Invoice</label>
                                                <button
                                                    type="button"
                                                    onClick={() => setModalIsOpen11(true)}
                                                    className="ok-btn w-100"
                                                    style={{ color: "black" }}
                                                >
                                                    <i className="bi bi-receipt-cutoff"></i>
                                                </button>
                                            </div>
                                        </>
                                    )}

                                    {isChecked2.EWay_Bill_No && (
                                        <div className="input-field1">
                                            <label>E-Way Bill No</label>
                                            <input
                                                type="text"
                                                placeholder="E-Way Bill No"
                                                value={formData.EwayBill}
                                                onChange={(e) => setFormData({ ...formData, EwayBill: e.target.value })}
                                            />
                                        </div>
                                    )}

                                    {isChecked2.Remark_SR_No && (
                                        <div className="input-field1">
                                            <label>Shipment Invoice</label>
                                            <button
                                                type="button"
                                                className="ok-btn"
                                                style={{ height: "35px" }}
                                                onClick={() => setModalIsOpen4(true)}
                                            >
                                                <i className="bi bi-plus"></i>
                                            </button>
                                        </div>
                                    )}
                                    <div className="input-field1">
                                        <label>Billing Type</label>
                                        <select value={formData.BillParty} onChange={(e) => setFormData({ ...formData, BillParty: e.target.value })}>
                                            <option value="" disabled>Select Billing Type</option>
                                            <option value="Client-wise Bill">Client-wise Bill</option>
                                            <option value="Shipper-wise Bill">Shipper-wise Bill</option>
                                            <option value="Vendor-wise Bill">Vendor-wise Bill</option>
                                            <option value="Product-wise Bill">Product-wise Bill</option>
                                            <option value="Consignee-wise Bill">Consignee-wise Bill</option>

                                        </select>
                                    </div>

                                    {isChecked2.Dispatch_Date && (
                                        <div className="input-field1">
                                            <label>Dispatch Date</label>
                                            <DatePicker
                                                selected={formData.DispatchDate ? new Date(formData.DispatchDate) : null}
                                                onChange={(date) =>
                                                    setFormData({ ...formData, DispatchDate: date })
                                                }
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="dd/mm/yyyy"
                                            />
                                        </div>
                                    )}
                                </div>

                            </form>




                            <div className="card mt-2" style={{ border: "transparent", padding: "0px" }}>
                                <div className="section-title">Charges Information</div>

                                <form
                                    action=""
                                    style={{ padding: "0px", margin: "0px", backgroundColor: "white" }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") e.preventDefault();
                                    }}
                                >
                                    <div className="fields2">
                                        {isChecked2.Package_Type && <div className="input-field1" style={{ whiteSpace: "nowrap" }}>
                                            <label>Package Type</label>
                                            <select name="" id="" value={formData.DoxSpx}
                                                onChange={(e) => setFormData({ ...formData, DoxSpx: e.target.value })}>
                                                <option value="Dox">Dox</option>
                                                <option value="Non Dox">Non Dox</option>
                                                <option value="Rate Per Kg">Rate Per Kg</option>
                                            </select>
                                        </div>}



                                        <div className="input-field1">
                                            <label>Qty</label>
                                            <input
                                                type="tel"
                                                placeholder="Qty"
                                                value={formData.QtyOrderEntry}
                                                onChange={(e) => setFormData({ ...formData, QtyOrderEntry: e.target.value })}
                                            />
                                        </div>

                                        <div className="input-field1">
                                            <label>Wt.Fixed</label>
                                            <select
                                                value={formData.RateType}
                                                onChange={(e) => setFormData({ ...formData, RateType: e.target.value })}
                                            >
                                                <option value="" disabled>Wt/Box</option>
                                                <option value="Weight">Weight</option>
                                                <option value="Fixed">Box</option>
                                            </select>
                                        </div>

                                        <div className="input-field1">
                                            <label>Actual Weight</label>
                                            <input
                                                type="tel"
                                                placeholder="Actual Weight"
                                                value={formData.ActualWt}
                                                onChange={(e) => setFormData({ ...formData, ActualWt: e.target.value })}
                                            />
                                        </div>

                                        <div className="input-field1">
                                            <label>Volumetric Weight</label>
                                            <input
                                                type="tel"
                                                placeholder="Volumetric Weight"
                                                value={formData.VolumetricWt}
                                                onChange={(e) => setFormData({ ...formData, VolumetricWt: e.target.value })}
                                            />
                                        </div>

                                        <div className="input-field1">
                                            <label>&nbsp;</label>
                                            <button
                                                type="button"
                                                className="ok-btn"
                                                onClick={() => setModalIsOpen9(true)}
                                                style={{ height: "35px", width: "100%", color: "black" }}
                                            >
                                                <i className="bi bi-calculator" style={{ fontSize: "20px" }}></i>
                                            </button>
                                        </div>

                                        <div className="input-field1">
                                            <label>Charged Weight</label>
                                            <input
                                                type="tel"
                                                placeholder="Charged Weight"
                                                value={formData.ChargedWt}
                                                onChange={(e) => setFormData({ ...formData, ChargedWt: e.target.value })}
                                            />
                                        </div>


                                        <div className="input-field1">
                                            <label>Rate Per Kg</label>
                                            <input
                                                type="tel"
                                                placeholder="Rate Per Kg"
                                                value={formData.RatePerkg}
                                                onChange={(e) => setFormData({ ...formData, RatePerkg: e.target.value })}
                                            />
                                        </div>

                                        {showBasicRate && (
                                            <div className="input-field1">
                                                <label>Freight Amount</label>
                                                <input
                                                    type="tel"
                                                    placeholder="Freight Amount"
                                                    value={formData.Rate}
                                                    readOnly
                                                />
                                            </div>
                                        )}

                                        {isChecked2.Fov_Charges && (
                                            <div className="input-field1">
                                                <label>FOV Charges</label>
                                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                    <input
                                                        type="tel" placeholder="FOv Charges" value={formData.FovChrgs} readOnly

                                                        style={{
                                                            width: "70%",
                                                            borderRight: "1px solid #ccc",
                                                            borderRadius: "4px 0 0 4px",
                                                        }}
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, FovChrgs: e.target.value })
                                                        }
                                                    />
                                                    <input
                                                        type="tel"
                                                        placeholder="%"
                                                        readOnly
                                                        style={{
                                                            width: "30%",
                                                            borderLeft: "none",
                                                            borderRadius: "0 4px 4px 0",
                                                            padding: "5px",
                                                            textAlign: "center",
                                                        }}
                                                        value={formData.FovPer !== "" ? `${formData.FovPer}%` : ""}
                                                        onChange={(e) => {
                                                            // ✅ Strip non-numeric chars before saving
                                                            const val = e.target.value.replace(/[^0-9.]/g, "");
                                                            setFormData({ ...formData, FovPer: val });
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                        )}

                                        {isChecked2.Docket_Charges && (
                                            <div className="input-field1">
                                                <label>Docket Charges</label>
                                                <input
                                                    type="tel"
                                                    placeholder="Docket Charges"
                                                    value={formData.DocketChrgs}
                                                    onChange={(e) => setFormData({ ...formData, DocketChrgs: e.target.value })}
                                                />
                                            </div>
                                        )}

                                        {isChecked2.Delivery_Charges && (
                                            <div className="input-field1">
                                                <label>Delivery Charges</label>
                                                <input
                                                    type="tel"
                                                    placeholder="Delivery Charges"
                                                    value={formData.DeliveryChrgs}
                                                    onChange={(e) => setFormData({ ...formData, DeliveryChrgs: e.target.value })}
                                                />
                                            </div>
                                        )}

                                        {isChecked2.Packing_Charges && (
                                            <div className="input-field1">
                                                <label>COD Charges</label>
                                                <input
                                                    type="tel"
                                                    placeholder="Packing Charges"
                                                    value={formData.PackingChrgs}
                                                    onChange={(e) => setFormData({ ...formData, PackingChrgs: e.target.value })}
                                                />
                                            </div>
                                        )}

                                        {isChecked2.Green_Charges && (
                                            <div className="input-field1">
                                                <label>Green Charges</label>
                                                <input
                                                    type="tel"
                                                    placeholder="Green Charges"
                                                    value={formData.GreenChrgs}
                                                    onChange={(e) => setFormData({ ...formData, GreenChrgs: e.target.value })}
                                                />
                                            </div>
                                        )}

                                        {isChecked2.Hamali_Charges && (
                                            <div className="input-field1">
                                                <label>CAF Charges</label>
                                                <input
                                                    type="tel"
                                                    placeholder="Hamali Charges"
                                                    value={formData.HamaliChrgs}
                                                    onChange={(e) => setFormData({ ...formData, HamaliChrgs: e.target.value })}
                                                />
                                            </div>
                                        )}

                                        {isChecked2.Other_Charges && (
                                            <div className="input-field1">
                                                <label>Other Charges</label>
                                                <input
                                                    type="tel"
                                                    placeholder="Other Charges"
                                                    value={formData.OtherCharges}
                                                    onChange={(e) => setFormData({ ...formData, OtherCharges: e.target.value })}
                                                />
                                            </div>
                                        )}

                                        {isChecked2.Insurance_Charges && (
                                            <div className="input-field1">
                                                <label>Insurance Charges</label>
                                                <input
                                                    type="tel"
                                                    placeholder="Insurance Charges"
                                                    value={formData.InsuranceChrgs}
                                                    onChange={(e) => setFormData({ ...formData, InsuranceChrgs: e.target.value })}
                                                />
                                            </div>
                                        )}

                                        {isChecked2.ODA_Charges && (
                                            <div className="input-field1">
                                                <label>ODA Charges</label>
                                                <input
                                                    type="tel"
                                                    placeholder="ODA Charges"
                                                    value={formData.ODAChrgs}
                                                    onChange={(e) => setFormData({ ...formData, ODAChrgs: e.target.value })}
                                                />
                                            </div>
                                        )}



                                        {Object.keys(label).map((key, index) => (
                                            isChecked[key] && (
                                                <div className="input-field1" key={index}>
                                                    {/* Dynamic Label */}
                                                    <label>{label[key]}</label>

                                                    {/* Input for entering Charges */}
                                                    <input
                                                        type="tel"
                                                        placeholder={label[key]}
                                                        value={formData[key]}
                                                        onChange={(e) =>
                                                            setFormData({
                                                                ...formData,
                                                                [`charge${index + 1}`]: e.target.value
                                                            })
                                                        }
                                                    />
                                                </div>
                                            )
                                        ))}

                                        {isChecked2.Fuel_Charges && (

                                            <div className="input-field1">
                                                <label>Fuel Charges</label>
                                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                    <input
                                                        type="tel" placeholder="Fuel Charges" value={formData.FuelCharges} readOnly

                                                        style={{
                                                            width: "70%",
                                                            borderRight: "1px solid #ccc",
                                                            borderRadius: "4px 0 0 4px",
                                                        }}
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, FuelCharges: e.target.value })
                                                        }
                                                    />
                                                    <input
                                                        type="tel"
                                                        placeholder="%"
                                                        readOnly
                                                        style={{
                                                            width: "30%",
                                                            borderLeft: "none",
                                                            borderRadius: "0 4px 4px 0",
                                                            padding: "5px",
                                                            textAlign: "center",
                                                        }}
                                                        value={formData.FuelPer !== "" ? `${formData.FuelPer}%` : ""}
                                                        onChange={(e) => {
                                                            // ✅ Strip non-numeric chars before saving
                                                            const val = e.target.value.replace(/[^0-9.]/g, "");
                                                            setFormData({ ...formData, FuelPer: val });
                                                        }}
                                                    />
                                                </div>
                                            </div>


                                        )}




                                        <div className="input-field1">
                                            <label>Total GST</label>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                <input
                                                    type="tel" placeholder="Total IGST" value={formData.TotalGST} readOnly

                                                    style={{
                                                        width: "70%",
                                                        borderRight: "1px solid #ccc",
                                                        borderRadius: "4px 0 0 4px",
                                                    }}
                                                    onChange={(e) =>
                                                        setFormData({ ...formData, TotalGST: e.target.value })
                                                    }
                                                />
                                                <input
                                                    type="tel"
                                                    placeholder="%"
                                                    readOnly
                                                    style={{
                                                        width: "30%",
                                                        borderLeft: "none",
                                                        borderRadius: "0 4px 4px 0",
                                                        padding: "5px",
                                                        textAlign: "center",
                                                    }}
                                                    value={formData.totalgstPer !== "" ? `${formData.totalgstPer}%` : ""}
                                                    onChange={(e) => {
                                                        // ✅ Strip non-numeric chars before saving
                                                        const val = e.target.value.replace(/[^0-9.]/g, "");
                                                        setFormData({ ...formData, totalgstPer: val });
                                                    }}
                                                />
                                            </div>
                                        </div>


                                        <div className="input-field1">
                                            <label>&nbsp;</label>
                                            <button
                                                type="button"
                                                className="ok-btn"
                                                onClick={() => setModalIsOpen3(true)}
                                            >
                                                <i className="bi bi-cash-coin" style={{ fontSize: "24px" }}></i>
                                            </button>
                                        </div>

                                        <div className="input-field1">
                                            <label>Total Amount</label>
                                            <input type="tel" placeholder="Total Amount" value={formData.TotalAmt} readOnly />
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>

                    </div>

                    <div className="bottom-card row"
                        style={{ width: "100%", display: 'flex', marginTop: "0.5rem", gap: '0.5rem', alignItems: "center", justifyContent: "center", textAlign: "center", padding: "0.5rem" }}>

                        {!open ? <>
                            {
                                !edit ? <button className="btn btn-success col-4" style={{ width: "90px" }} onClick={handleSubmit} type="button">Save</button>
                                    : <button className="btn btn-primary col-4" style={{ width: "90px" }} onClick={handleUpdate} type="button">Update</button>
                            }


                            <button className="btn btn-warning col-4" style={{ width: "90px" }}  onClick={(e)=>(e, formData.DocketNo, "manual")} type="button">Search</button>
                        </>
                            :
                            <
                                >
                                <button
                                    className="btn btn-dark"
                                    style={{ width: "90px" }}
                                    onClick={() => { setModalIsOpen10(true); setOpen(false) }}
                                >
                                    Label
                                </button>b
                                <button
                                    className="btn btn-info"
                                    style={{ width: "90px" }}
                                    onClick={() => { setModalIsOpen7(true); setOpen(false) }}
                                >
                                    Setup
                                </button>

                                <button
                                    className="btn btn-danger"
                                    style={{ width: "90px" }}
                                    onClick={() => { setOpen(false); handleDelete(formData.DocketNo) }}
                                    type="button"
                                >
                                    Delete
                                </button>
                            </>
                        }

                        {/* three dots wrapper */}
                        <div className="btn btn-light col-4"
                            style={{ height: "38px", width: "90px", display: "flex", alignItems: "center", justifyContent: "center" }}
                            onClick={() => setOpen(!open)}>
                            <PiDotsThreeOutlineVerticalFill
                                style={{ fontSize: "30px", cursor: "pointer" }}
                            />
                        </div>
                    </div>



                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen}
                        className="custom-modal-receiver" contentLabel="Modal"
                        style={{
                            content: {
                                width: '90%',
                                top: '50%',             // Center vertically
                                left: '50%',
                                whiteSpace: "nowrap"
                            },
                        }}>
                        <div className="custom-modal-content">
                            <div className="header-tittle">
                                <header>Shipper Name Master</header>
                            </div>

                            <div className='container2'>
                                <form onSubmit={handleSaveShipper}>
                                    <div className="fields2">
                                        <div className="input-field3">
                                            <label htmlFor="">Code </label>
                                            <input
                                                type="text" value={addShipper.shipperCode}
                                                onChange={(e) => setAddShipper({ ...addShipper, ShipperCode: e.target.value })}
                                                placeholder="Enter Code/ Generate Code"
                                                maxLength="3" />
                                        </div>

                                        <div className="input-field3">
                                            <button type="button" className="ok-btn" style={{ marginTop: "18px", height: "35px" }}
                                                onClick={handleGenerateCode}>Generate Code</button>
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">Shipper Name</label>
                                            <input type="text" value={addShipper.shipperName}
                                                onChange={(e) => setAddShipper({ ...addShipper, shipperName: e.target.value })}
                                                placeholder="Shipper Name" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">Address</label>
                                            <input type="text" value={addShipper.shipperAdd1}
                                                onChange={(e) => setAddShipper({ ...addShipper, shipperAdd1: e.target.value })}
                                                placeholder="Address" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">Address</label>
                                            <input type="text" value={addShipper.shipperAdd2}
                                                onChange={(e) => setAddShipper({ ...addShipper, shipperAdd2: e.target.value })}
                                                placeholder="Address" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">Pin code</label>
                                            <input type="tel" id="pincode" name="pincode" maxLength="6"
                                                value={addShipper.shipperPin}
                                                onChange={(e) => setAddShipper({ ...addShipper, shipperPin: e.target.value })}
                                                placeholder="Pin Code" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">City Name</label>
                                            <Select
                                                className="blue-selectbooking"
                                                classNamePrefix="blue-selectbooking"
                                                options={getCity.map((city) => ({
                                                    value: city.City_Code,
                                                    label: city.City_Name,
                                                }))}
                                                value={
                                                    addShipper.cityCode
                                                        ? {
                                                            value: addShipper.cityCode,
                                                            label:
                                                                getCity.find((c) => c.City_Code === addShipper.cityCode)
                                                                    ?.City_Name || "",
                                                        }
                                                        : null
                                                }
                                                onChange={(selected) =>
                                                    setAddShipper({
                                                        ...addShipper,
                                                        cityCode: selected ? selected.value : "",
                                                    })
                                                }
                                                placeholder="Select City"
                                                isSearchable={true}
                                                isClearable={false}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                            />

                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">State Name</label>
                                            <Select
                                                className="blue-selectbooking"
                                                classNamePrefix="blue-selectbooking"
                                                options={getState.map((st) => ({
                                                    value: st.State_Code,
                                                    label: st.State_Name,
                                                }))}
                                                value={
                                                    addShipper.stateCode
                                                        ? {
                                                            value: addShipper.stateCode,
                                                            label:
                                                                getState.find((s) => s.State_Code === addShipper.stateCode)
                                                                    ?.State_Name || "",
                                                        }
                                                        : null
                                                }
                                                onChange={(selected) =>
                                                    setAddShipper({
                                                        ...addShipper,
                                                        stateCode: selected ? selected.value : "",
                                                    })
                                                }
                                                placeholder="Select State"
                                                isSearchable={true}
                                                isClearable={false}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                            />

                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">Mobile No</label>
                                            <input type="tel" maxLength="10" id="mobile"
                                                value={addShipper.shipperMob}
                                                onChange={(e) => setAddShipper({ ...addShipper, shipperMob: e.target.value })}
                                                name="mobile" pattern="[0-9]{10}" placeholder="Mobile No" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">Email ID</label>
                                            <input type="email" value={addShipper.shipperEmail}
                                                onChange={(e) => setAddShipper({ ...addShipper, shipperEmail: e.target.value })}
                                                placeholder="Email Id" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">GST No</label>
                                            <input type="text" value={addShipper.gstNo}
                                                onChange={(e) => setAddShipper({ ...addShipper, gstNo: e.target.value })}
                                                placeholder="Gst No" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">Company Name</label>
                                            <input type="text" value={addShipper.company}
                                                onChange={(e) => setAddShipper({ ...addShipper, company: e.target.value })}
                                                placeholder="Company Name" />
                                        </div>

                                    </div>

                                    <div className='bottom-buttons'>
                                        <button type='submit' className='ok-btn'>Submit</button>
                                        <button onClick={() => setModalIsOpen(false)} className='ok-btn'>close</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal >

                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen1}
                        className="custom-modal-receiver" contentLabel="Modal"
                        style={{
                            content: {
                                width: '90%',
                                top: '50%',             // Center vertically
                                left: '50%',
                                whiteSpace: "nowrap"
                            },
                        }}>
                        <div className="custom-modal-content">
                            <div className="header-tittle">
                                <header>Consignee Name Master</header>
                            </div>

                            <div className='container2'>
                                <form onSubmit={handleSaveReceiver}>
                                    <div className="fields2">
                                        <div className="input-field3">
                                            <label htmlFor="">Code </label>
                                            <input
                                                type="text" value={addReceiver.receiverCode}
                                                onChange={(e) => setAddReceiver({ ...addReceiver, receiverCode: e.target.value })}
                                                placeholder="Enter Code/ Generate Code"
                                                maxLength="3" />
                                        </div>


                                        <div className="input-field3">
                                            <button type="button" className="ok-btn" style={{ marginTop: "18px", height: "35px" }}
                                                onClick={handleGenerateCode1}>Generate Code</button>
                                        </div>


                                        <div className="input-field3">
                                            <label htmlFor="">Consignee Name</label>
                                            <input type="text" value={addReceiver.receiverName}
                                                onChange={(e) => setAddReceiver({ ...addReceiver, receiverName: e.target.value })}
                                                placeholder="Consignee Name" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">Address</label>
                                            <input type="text" value={addReceiver.receiverAdd1}
                                                onChange={(e) => setAddReceiver({ ...addReceiver, receiverAdd1: e.target.value })}
                                                placeholder="Address" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">Address</label>
                                            <input type="text" value={addReceiver.receiverAdd2}
                                                onChange={(e) => setAddReceiver({ ...addReceiver, receiverAdd2: e.target.value })}
                                                placeholder="Address" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">Pin code</label>
                                            <input type="tel" id="pincode" name="pincode" maxLength="6"
                                                value={addReceiver.receiverPin}
                                                onChange={(e) => setAddReceiver({ ...addReceiver, receiverPin: e.target.value })}
                                                placeholder="Pin Code" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">City Name</label>
                                            <Select
                                                className="blue-selectbooking"
                                                classNamePrefix="blue-selectbooking"
                                                options={getCity.map((city) => ({
                                                    value: city.City_Code,
                                                    label: city.City_Name,
                                                }))}
                                                value={
                                                    addReceiver.cityCode
                                                        ? {
                                                            value: addReceiver.cityCode,
                                                            label:
                                                                getCity.find((c) => c.City_Code === addReceiver.cityCode)
                                                                    ?.City_Name || "",
                                                        }
                                                        : null
                                                }
                                                onChange={(selected) =>
                                                    setAddReceiver({
                                                        ...addReceiver,
                                                        cityCode: selected ? selected.value : "",
                                                    })
                                                }
                                                placeholder="Select City"
                                                isSearchable={true}
                                                isClearable={false}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                            />

                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">State Name</label>
                                            <Select
                                                className="blue-selectbooking"
                                                classNamePrefix="blue-selectbooking"
                                                options={getState.map((st) => ({
                                                    value: st.State_Code,
                                                    label: st.State_Name,
                                                }))}
                                                value={
                                                    addReceiver.stateCode
                                                        ? {
                                                            value: addReceiver.stateCode,
                                                            label:
                                                                getState.find((s) => s.State_Code === addReceiver.stateCode)
                                                                    ?.State_Name || "",
                                                        }
                                                        : null
                                                }
                                                onChange={(selected) =>
                                                    setAddReceiver({
                                                        ...addReceiver,
                                                        stateCode: selected ? selected.value : "",
                                                    })
                                                }
                                                placeholder="Select State"
                                                isSearchable={true}
                                                isClearable={false}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                            />

                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">Mobile No</label>
                                            <input type="tel" maxLength="10" id="mobile"
                                                value={addReceiver.receiverMob}
                                                onChange={(e) => setAddReceiver({ ...addReceiver, receiverMob: e.target.value })}
                                                name="mobile" pattern="[0-9]{10}" placeholder="Mobile No" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">Email ID</label>
                                            <input type="email" value={addReceiver.receiverEmail}
                                                onChange={(e) => setAddReceiver({ ...addReceiver, receiverEmail: e.target.value })}
                                                placeholder="Email Id" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">GST No</label>
                                            <input type="text" value={addReceiver.gstNo}
                                                onChange={(e) => setAddReceiver({ ...addReceiver, gstNo: e.target.value })}
                                                placeholder="Gst No" />
                                        </div>

                                        <div className="input-field3">
                                            <label htmlFor="">HSN No</label>
                                            <input type="text" value={addReceiver.hsnNo}
                                                onChange={(e) => setAddReceiver({ ...addReceiver, hsnNo: e.target.value })}
                                                placeholder="HSN No" />
                                        </div>

                                        <div className="input-field2">
                                            <div className="select-radio">
                                                <input type="checkbox" name="mode" id="SMS"
                                                    checked={addReceiver.sms}
                                                    onChange={(e) => setAddReceiver({ ...addReceiver, sms: e.target.checked })} />
                                                <img src={sms} />

                                                <input type="checkbox" name="mode" id="E-mail"
                                                    checked={addReceiver.emailId}
                                                    onChange={(e) => setAddReceiver({ ...addReceiver, emailId: e.target.checked })} />
                                                <img src={mail} />

                                                <input type="checkbox" name="mode" id="WHATSAPP"
                                                    checked={addReceiver.whatsApp}
                                                    onChange={(e) => setAddReceiver({ ...addReceiver, whatsApp: e.target.checked })} />
                                                <img src={whatsapp} />
                                            </div>
                                        </div>

                                    </div>

                                    <div className='bottom-buttons'>
                                        <button type='submit' className='ok-btn'>Submit</button>
                                        <button onClick={() => setModalIsOpen1(false)} className='ok-btn'>close</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal >

                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen2}
                        className="custom-modal-volumetric" contentLabel="Modal">
                        <div className="custom-modal-content">
                            <div className="header-tittle">
                                <header>Vendor</header>
                            </div>
                            <div className='container2'>
                                <form>
                                    <div className="fields2">
                                        <div className="input-field1">
                                            <label htmlFor="">Vendor 2</label>
                                            <select value={vendorData.Vendor_Code1}
                                                onChange={(e) => setVendorData({ ...vendorData, Vendor_Code1: e.target.value })}>
                                                <option disabled value="">Select Vendor</option>
                                                {getVendor.map((vendor, index) => (
                                                    <option value={vendor.Vendor_Code} key={index}>{vendor.Vendor_Name}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="input-field1">
                                            <label htmlFor="">Vendor Docket No 2</label>
                                            <input type="tel" placeholder=" Vendor Docket No" value={vendorData.VendorAwbNo1}
                                                onChange={(e) => setVendorData({ ...vendorData, VendorAwbNo1: e.target.value })} />
                                        </div>

                                        <div className="input-field1">
                                            <label htmlFor="">Vendor 3</label>
                                            <select value={vendorData.Vendor_Code2}
                                                onChange={(e) => setVendorData({ ...vendorData, Vendor_Code2: e.target.value })}>
                                                <option disabled value="">Select Vendor</option>
                                                {getVendor.map((vendor, index) => (
                                                    <option value={vendor.Vendor_Code} key={index}>{vendor.Vendor_Name}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="input-field1">
                                            <label htmlFor="">Vendor Docket No 3</label>
                                            <input type="tel" placeholder=" Vendor Docket No" value={vendorData.VendorAwbNo2}
                                                onChange={(e) => setVendorData({ ...vendorData, VendorAwbNo2: e.target.value })} />
                                        </div>

                                    </div>
                                    <div className="bottom-buttons">
                                        <button className="ok-btn">Submit</button>
                                        <button className="ok-btn" onClick={() => setModalIsOpen2(false)}>Cancel</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal >



                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen3}
                        className="custom-modal-volumetric" contentLabel="GST Details Modal">
                        <div className="custom-modal-content">
                            <div className="header-tittle">
                                <header>GST Details</header>
                            </div>
                            <div className='container2'>
                                <form>
                                    <div className="fields2">
                                        <div className="input-field1" style={{ width: "60%" }}>
                                            <label htmlFor="">CGST Amount</label>
                                            <input type="text" placeholder="CGST Charges" value={gstData.CGSTAMT || 0} readOnly />
                                        </div>
                                        <div className="input-field1" style={{ width: "30%" }}>
                                            <label htmlFor="">CGST %</label>
                                            <input type="text" placeholder="%" value={gstData.CGSTPer || 0} readOnly />
                                        </div>
                                    </div>

                                    <div className="fields2">
                                        <div className="input-field1" style={{ width: "60%" }}>
                                            <label htmlFor="">SGST Amount</label>
                                            <input type="text" placeholder="SGST Charges" value={gstData.SGSTAMT || 0} readOnly />
                                        </div>
                                        <div className="input-field1" style={{ width: "30%" }}>
                                            <label htmlFor="">SGST %</label>
                                            <input type="text" placeholder="%" value={gstData.SGSTPer || 0} readOnly />
                                        </div>
                                    </div>

                                    <div className="fields2">
                                        <div className="input-field1" style={{ width: "60%" }}>
                                            <label htmlFor="">IGST Amount</label>
                                            <input type="text" placeholder="IGST Charges" value={gstData.IGSTAMT || 0} readOnly />
                                        </div>
                                        <div className="input-field1" style={{ width: "30%" }}>
                                            <label htmlFor="">IGST %</label>
                                            <input type="text" placeholder="%" value={gstData.IGSTPer || 0} readOnly />
                                        </div>
                                    </div>

                                    <div className="fields2">
                                        <div className="input-field1" style={{ width: "60%" }}>
                                            <label htmlFor="">Total GST</label>
                                            <input type="text" placeholder="Total GST" value={gstData.TotalGST || 0} readOnly />
                                        </div>
                                        <div className="input-field1" style={{ width: "30%" }}>
                                            <label htmlFor="">Total %</label>
                                            <input type="text" placeholder="%" value={gstData.GSTPer || 0} readOnly />
                                        </div>
                                    </div>

                                    <div className="bottom-buttons">
                                        <button className="ok-btn" type="button" onClick={() => setModalIsOpen3(false)}>OK</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal>




                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen4}
                        className="custom-modal-stock" contentLabel="Modal"
                        style={{
                            content: {
                                width: '90%',
                                top: '50%',             // Center vertically
                                left: '50%',
                                height: "auto",
                                whiteSpace: "nowrap"
                            },
                        }}>
                        <div className="custom-modal-content">
                            <div className="header-tittle">
                                <header>Shipment Invoice</header>
                            </div>
                            <div className='container2'>
                                <form>
                                    <div className="fields2">

                                        <div className="input-field2">
                                            <label htmlFor="">Invoice Type</label>
                                            <select value={remarkData.invoiceType} onChange={(e) => setRemarkData({ ...remarkData, invoiceType: e.target.value })} >
                                                <option value="" disabled>Select Invoice</option>
                                                <option value="INVOICE">INVOICE</option>
                                            </select>
                                        </div>

                                        <div className="input-field2">
                                            <label htmlFor="">Currency</label>
                                            <select value={remarkData.curr} onChange={(e) => setRemarkData({ ...remarkData, curr: e.target.value })} >

                                                <option value="INR">INR</option>
                                                <option value="USD">USD</option>
                                            </select>
                                        </div>

                                        <div className="input-field2">
                                            <label htmlFor="">Incoterms</label>
                                            <select value={remarkData.inco} onChange={(e) => setRemarkData({ ...remarkData, inco: e.target.value })} >
                                                <option value="CRF">CRF</option>
                                                <option value="DDP">DDP</option>
                                                <option value="DDU">DDU</option>

                                            </select>
                                        </div>

                                        <div className="input-field2">
                                            <label htmlFor="">Note</label>
                                            <select
                                                value={remarkData.note}
                                                onChange={(e) => {
                                                    const selected = e.target.value;
                                                    let temp = "";

                                                    if (selected === "GIFT") {
                                                        temp = "UNSOLICITED GIFT SENT TO MY FRIENDS & FAMILY MEMBERS FOR THEIR PERSONAL USE ONLY";
                                                    } else if (selected === "SAMPLE") {
                                                        temp = "FREE TRADE SAMPLES OF NO COMMERCIAL VALUE";
                                                    } else if (selected === "CARGO") {
                                                        temp = "COMMERCIAL SHIPMENT";
                                                    }

                                                    setRemarkData({
                                                        ...remarkData,
                                                        note: selected,
                                                        noteCont: temp, // ✅ correct field
                                                    });
                                                }}
                                            >
                                                <option value="" disabled>Select note</option>
                                                <option value="GIFT">GIFT</option>
                                                <option value="SAMPLE">SAMPLE</option>
                                                <option value="CARGO">CARGO</option>
                                            </select>

                                        </div>

                                        <div className="input-field1">
                                            <label htmlFor="" style={{ visibility: "hidden" }}>Note Content</label>
                                            <input type="text" value={remarkData.noteCont}
                                                readOnly
                                                onChange={(e) => setRemarkData({ ...remarkData, noteCont: e.target.value })} />
                                        </div>

                                        <div className="input-field">
                                            <label htmlFor="">Remark</label>
                                            <input type="text" placeholder="Remark" value={remarkData.Remark}
                                                onChange={(e) => setRemarkData({ ...remarkData, Remark: e.target.value })} />
                                        </div>

                                        <div className="input-field">
                                            <label htmlFor="">Content</label>
                                            <input type="text" placeholder="Content" value={remarkData.MHWNo}
                                                onChange={(e) => setRemarkData({ ...remarkData, MHWNo: e.target.value })} />
                                        </div>
                                    </div>
                                    <div className="bottom-buttons">
                                        <button className="ok-btn" onClick={() => setModalIsOpen4(false)}>Submit</button>
                                        <button className="ok-btn" onClick={() => setModalIsOpen4(false)}>Cancel</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal >

                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen5}
                        style={{
                            content: {
                                width: '90%',
                                top: '50%',             // Center vertically
                                left: '50%',
                                height: "auto",
                                whiteSpace: "nowrap"
                            },
                        }}
                        className="custom-modal-mode" contentLabel="Modal">
                        <div className="custom-modal-content">
                            <div className="header-tittle">
                                <header> Vendor Volumetric</header>
                            </div>
                            <div className='container2'>
                                <div className="table-container" style={{ padding: "10px" }}>
                                    <table className="table table-bordered table-sm">
                                        <thead className="table-info">
                                            <tr>
                                                <th>Length</th>
                                                <th>Width</th>
                                                <th>Height</th>
                                                <th>DIV</th>
                                                <th>QTY</th>
                                                <th>Vol Wt</th>
                                                <th>Actual Wt</th>
                                                <th>Charged Wt</th>
                                                <th className="w-60">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-body">
                                            <tr>
                                                <td>
                                                    <input type="tel" placeholder="Length" name="Length"
                                                        style={{ textAlign: "center" }} className="form-control" value={vendorVolumetric.Length}
                                                        onChange={handleVendorChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="Width" name="Width"
                                                        style={{ textAlign: "center" }} className="form-control" value={vendorVolumetric.Width}
                                                        onChange={handleVendorChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="Height" name="Height"
                                                        style={{ textAlign: "center" }} className="form-control" value={vendorVolumetric.Height}
                                                        onChange={handleVendorChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="DIV" name="DivideBy"
                                                        style={{ textAlign: "center" }} className="form-control" value={vendorVolumetric.DivideBy}
                                                        onChange={handleVendorChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="QTY" name="Qty"
                                                        style={{ textAlign: "center" }} className="form-control" value={vendorVolumetric.Qty}
                                                        onChange={handleVendorChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="Vol Wt" name="VolmetricWt"
                                                        style={{ textAlign: "center" }} className="form-control" value={vendorVolumetric.VolmetricWt}
                                                        onChange={handleVendorChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="Actual Wt" name="ActualWt"
                                                        style={{ textAlign: "center" }} className="form-control" value={vendorVolumetric.ActualWt}
                                                        onChange={handleVendorChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="Charged Wt" name="ChargeWt"
                                                        style={{ textAlign: "center" }} className="form-control" value={vendorVolumetric.ChargeWt}
                                                        onChange={handleVendorChange} />
                                                </td>
                                                <td>
                                                    <button className="ok-btn" style={{ width: "40px", height: "30px", margin: "0px 10px", marginTop: "3px", paddingBottom: "15px" }}
                                                        onClick={handleVendorAddRow}>
                                                        <i className="bi bi-plus" style={{ fontSize: "22px" }}></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            {vendorsubmittedData.map((data, index) => (
                                                <tr key={index}>
                                                    <td>{data.Length}</td>
                                                    <td>{data.Width}</td>
                                                    <td>{data.Height}</td>
                                                    <td>{data.DivideBy}</td>
                                                    <td>{data.Qty}</td>
                                                    <td>{data.VolmetricWt}</td>
                                                    <td>{data.ActualWt}</td>
                                                    <td>{data.ChargeWt}</td>
                                                    <td>
                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                                                            <button className='edit-btn'
                                                                onClick={() => {
                                                                    setVendorvolumetric({
                                                                        Length: data.Length,
                                                                        Width: data.Width,
                                                                        Height: data.Height,
                                                                        Qty: data.Qty,
                                                                        DivideBy: data.DivideBy,
                                                                        VolmetricWt: data.VolmetricWt,
                                                                        ActualWt: data.ActualWt,
                                                                        ChargeWt: data.ChargeWt,
                                                                    })
                                                                    setEditIndex(index);
                                                                }}>
                                                                <i className='bi bi-pen'></i>
                                                            </button>
                                                            <button onClick={() => {
                                                                setVendorSubmittedData(vendorsubmittedData.filter((_, ind) => ind !== index));
                                                                setEditIndex(null);
                                                                setVendorvolumetric({
                                                                    Length: 0,
                                                                    Width: 0,
                                                                    Height: 0,
                                                                    Qty: 0,
                                                                    DivideBy: "",
                                                                    VolmetricWt: 0,
                                                                    ActualWt: 0,
                                                                    ChargeWt: 0
                                                                });
                                                            }}
                                                                className='edit-btn'><i className='bi bi-trash'></i></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <form action="" style={{ backgroundColor: "white", justifyContent: "center" }}>
                                    <div className="fields2">
                                        <div className="input-field1">
                                            <label htmlFor="">Total Vol. Weight</label>
                                            <input type="text" placeholder="Total Vol. Weight" value={totalVolWt} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label htmlFor="">Total Act. Weight</label>
                                            <input type="text" placeholder="Total Act. Weight" value={totalActWt} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label htmlFor="">Total Cha. Weight</label>
                                            <input type="text" placeholder="Total Cha. Weight" value={totalChargeWt} readOnly />
                                        </div>
                                    </div>
                                </form>
                                <div className="bottom-buttons">
                                    <button className="ok-btn" onClick={() => setModalIsOpen5(false)}>Submit</button>
                                    <button className="ok-btn" onClick={() => setModalIsOpen5(false)}>Cancel</button>
                                </div>
                            </div>


                        </div>
                    </Modal >

                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen9}
                        style={{
                            content: {
                                width: '90%',
                                top: '50%',             // Center vertically
                                left: '50%',
                                height: "auto",
                                whiteSpace: "nowrap"
                            },
                        }}
                        className="custom-modal-mode" contentLabel="Modal">
                        <div className="custom-modal-content">
                            <div className="header-tittle">
                                <header>Volumetric Calculate</header>
                            </div>
                            <div className='container2'>
                                <div className="table-container" style={{ padding: "10px" }}>
                                    <table className="table table-bordered table-sm">
                                        <thead className="table-info">
                                            <tr>
                                                <th>Length</th>
                                                <th>Width</th>
                                                <th>Height</th>
                                                <th>DIV</th>
                                                <th>QTY</th>
                                                <th>Volumetric Wt</th>
                                                <th>Actual Wt</th>
                                                <th>Charged Wt</th>
                                                <th className="w-60">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-body">
                                            <tr>
                                                <td>
                                                    <input type="tel" placeholder="Length" name="Length"
                                                        style={{ textAlign: "center" }} className="form-control" value={volumetricData.Length}
                                                        onChange={handleChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="Width" name="Width"
                                                        style={{ textAlign: "center" }} className="form-control" value={volumetricData.Width}
                                                        onChange={handleChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="Height" name="Height"
                                                        style={{ textAlign: "center" }} className="form-control" value={volumetricData.Height}
                                                        onChange={handleChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="DIV" name="DivideBy"
                                                        style={{ textAlign: "center" }} className="form-control" value={volumetricData.DivideBy}
                                                        onChange={handleChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="QTY" name="Qty"
                                                        style={{ textAlign: "center" }} className="form-control" value={volumetricData.Qty}
                                                        onChange={handleChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="Vol Wt" name="VolmetricWt"
                                                        style={{ textAlign: "center" }} className="form-control" value={volumetricData.VolmetricWt}
                                                        onChange={handleChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="Actual Wt" name="ActualWt"
                                                        style={{ textAlign: "center" }} className="form-control" value={volumetricData.ActualWt}
                                                        onChange={handleChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="Charged Wt" name="ChargeWt"
                                                        style={{ textAlign: "center" }} className="form-control" value={volumetricData.ChargeWt}
                                                        onChange={handleChange} />
                                                </td>
                                                <td>

                                                    <button className="ok-btn" style={{ width: "40px", height: "30px", margin: "0px 10px", marginTop: "3px", paddingBottom: "15px" }}
                                                        onClick={handleAddRow}>
                                                        <i className="bi bi-plus" style={{ fontSize: "22px" }}></i>
                                                    </button>
                                                </td>
                                            </tr>

                                            {submittedData.map((data, index) => (
                                                <tr key={index}>
                                                    <td>{data.Length}</td>
                                                    <td>{data.Width}</td>
                                                    <td>{data.Height}</td>
                                                    <td>{data.DivideBy}</td>
                                                    <td>{data.Qty}</td>
                                                    <td>{data.VolmetricWt}</td>
                                                    <td>{data.ActualWt}</td>
                                                    <td>{data.ChargeWt}</td>
                                                    <td>
                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                                                            <button className='edit-btn'
                                                                onClick={() => {
                                                                    setVolumetricData({
                                                                        Length: data.Length,
                                                                        Width: data.Width,
                                                                        Height: data.Height,
                                                                        Qty: data.Qty,
                                                                        DivideBy: data.DivideBy,
                                                                        VolmetricWt: data.VolmetricWt,
                                                                        ActualWt: data.ActualWt,
                                                                        ChargeWt: data.ChargeWt,
                                                                    })
                                                                    setEditIndex(index);
                                                                }}>
                                                                <i className='bi bi-pen'></i>
                                                            </button>
                                                            <button onClick={() => {
                                                                setSubmittedData(submittedData.filter((_, ind) => ind !== index));
                                                                setEditIndex(null);
                                                                setVolumetricData({
                                                                    Length: 0,
                                                                    Width: 0,
                                                                    Height: 0,
                                                                    Qty: 0,
                                                                    DivideBy: "",
                                                                    VolmetricWt: 0,
                                                                    ActualWt: 0,
                                                                    ChargeWt: 0
                                                                });
                                                            }}
                                                                className='edit-btn'><i className='bi bi-trash'></i></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <form action="" style={{ backgroundColor: "white", justifyContent: "center" }}>
                                    <div className="fields2">
                                        <div className="input-field1">
                                            <label htmlFor="">Total Vol. Weight</label>
                                            <input type="text" placeholder="Total Vol. Weight" value={totalVolWt1} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label htmlFor="">Total Act. Weight</label>
                                            <input type="text" placeholder="Total Act. Weight" value={totalActWt1} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label htmlFor="">Total Cha. Weight</label>
                                            <input type="text" placeholder="Total Cha. Weight" value={totalChargeWt1} readOnly />
                                        </div>
                                    </div>
                                </form>

                                <div className="bottom-buttons">
                                    <button className="ok-btn" onClick={() => setModalIsOpen9(false)}>Submit</button>
                                    <button className="ok-btn" onClick={() => setModalIsOpen9(false)}>Cancel</button>
                                </div>
                            </div>


                        </div>
                    </Modal >

                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen6}
                        style={{
                            content: {
                                width: '90%',
                                top: '50%',             // Center vertically
                                left: '50%',
                                height: "auto",
                                whiteSpace: "nowrap"
                            },
                        }}
                        className="custom-modal-mode" contentLabel="Modal">
                        <div className="custom-modal-content">
                            <div className="header-tittle">
                                <header>Invoice Details</header>
                            </div>
                            <div className='container2'>
                                <div className="table-container" style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                                    <table className="table table-bordered table-sm">
                                        <thead className="table-info">
                                            <tr>
                                                <th>PO No</th>
                                                <th >PO Date</th>
                                                <th>Currency</th>
                                                <th>Invoice No</th>
                                                <th>Invoice Value</th>
                                                <th>Description</th>
                                                <th>QTY</th>
                                                <th>E-Way Date</th>
                                                <th>E-Way Bill No</th>
                                                <th>Remark</th>
                                                <th>Invoice Img</th>
                                                <th className="w-60">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-body">
                                            <tr>
                                                <td>
                                                    <input type="tel" placeholder="PO No" name="PoNo"
                                                        style={{ textAlign: "center" }} className="form-control" value={invoiceData.PoNo}
                                                        onChange={handleInvoiceDetailChange} />
                                                </td>
                                                <td style={{ width: "150px" }}>
                                                    <DatePicker

                                                        portalId="root-portal"
                                                        className="form-control"
                                                        selected={invoiceData.PoDate ? new Date(invoiceData.PoDate) : null}
                                                        onChange={(date) =>
                                                            setInvoiceData({ ...invoiceData, PoDate: date })
                                                        }
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="dd/mm/yyyy"
                                                    />
                                                </td>
                                                <td>
                                                    <select name="Currency" id="Currency" className="form-control"
                                                        value={invoiceData.Currency} onChange={handleInvoiceDetailChange}>
                                                        <option value="INR">INR</option>
                                                        <option value="USD">USD</option>
                                                        <option value="EURO">EURO</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="Invoice No" name="InvoiceNo"
                                                        style={{ textAlign: "center" }} className="form-control" value={invoiceData.InvoiceNo}
                                                        onChange={handleInvoiceDetailChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="Invoice Value" name="InvoiceValue"
                                                        style={{ textAlign: "center" }} className="form-control" value={invoiceData.InvoiceValue}
                                                        onChange={handleInvoiceDetailChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="Description" name="Description"
                                                        style={{ textAlign: "center" }} className="form-control" value={invoiceData.Description}
                                                        onChange={handleInvoiceDetailChange} />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="QTY" name="Qty"
                                                        style={{ textAlign: "center" }} className="form-control" value={invoiceData.Qty}
                                                        onChange={handleInvoiceDetailChange} />
                                                </td>
                                                <td>
                                                    <DatePicker
                                                        portalId="root-portal"
                                                        className="form-control"
                                                        selected={invoiceData.EwayBillDate ? new Date(invoiceData.EwayBillDate) : null}
                                                        onChange={(date) =>
                                                            setInvoiceData({ ...invoiceData, EwayBillDate: date })
                                                        }
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="dd/mm/yyyy"
                                                    />
                                                </td>
                                                <td>
                                                    <input type="tel" placeholder="E-Way Bill No" name="EWayBillNo"
                                                        style={{ textAlign: "center" }} className="form-control" value={invoiceData.EWayBillNo}
                                                        onChange={handleInvoiceDetailChange} />
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="Reamrk" name="Remark"
                                                        style={{ textAlign: "center" }} className="form-control" value={invoiceData.Remark}
                                                        onChange={handleInvoiceDetailChange} />
                                                </td>
                                                <td>
                                                    <input type="file" style={{ textAlign: "center" }} className="form-control"
                                                        value={invoiceData.InvoiceImg} name="InvoiceImg"
                                                        onChange={handleInvoiceDetailChange} />
                                                </td>
                                                <td>
                                                    <button className="ok-btn" style={{ width: "40px", height: "30px", margin: "0px 10px", marginTop: "3px", paddingBottom: "15px", fontSize: "22px" }}
                                                        onClick={handleInvoiceAddRow}>
                                                        <i className="bi bi-plus"></i>
                                                    </button>
                                                </td>
                                            </tr>

                                            {InvoicesubmittedData?.map((data, index) => (
                                                <tr key={index}>
                                                    <td>{data.PoNo}</td>
                                                    <td>{data.PoDate ? (data.PoDate).toLocaleDateString("en-GB") : ""}</td>
                                                    <td>{data.Currency}</td>
                                                    <td>{data.InvoiceNo}</td>
                                                    <td>{data.InvoiceValue}</td>
                                                    <td>{data.Description}</td>
                                                    <td>{data.Qty}</td>
                                                    <td>{data.EwayBillDate ? (data.EwayBillDate).toLocaleDateString("en-GB") : ""}</td>
                                                    <td>{data.EWayBillNo}</td>
                                                    <td>{data.Remark}</td>
                                                    <td>{data.InvoiceImg}</td>
                                                    <td>
                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                                                            <button className='edit-btn'
                                                                onClick={() => {
                                                                    setInvoiceData({
                                                                        PoNo: data.PoNo,
                                                                        PoDate: data.PoDate,
                                                                        Currency: data.Currency,
                                                                        InvoiceNo: data.InvoiceNo,
                                                                        InvoiceValue: data.InvoiceValue,
                                                                        Description: data.Description,
                                                                        Qty: data.Qty,
                                                                        EWayBillNo: data.EWayBillNo,
                                                                        EwayBillDate: data.EwayBillDate,
                                                                        Remark: data.Remark,
                                                                        InvoiceImg: data.InvoiceImg,
                                                                    });
                                                                    setEditIndex(index);
                                                                }}>
                                                                <i className='bi bi-pen'></i>
                                                            </button>
                                                            <button onClick={() => {
                                                                setInvoiceSubmittedData(InvoicesubmittedData.filter((_, ind) => ind !== index));
                                                                setEditIndex(null);
                                                                setInvoiceData({
                                                                    PoNo: "",
                                                                    PoDate: getTodayDate(),
                                                                    InvoiceNo: "",
                                                                    InvoiceValue: 0,
                                                                    Description: "",
                                                                    Qty: 0,
                                                                    Currency: "",
                                                                    EwayBillDate: getTodayDate(),
                                                                    EWayBillNo: "",
                                                                    Remark: "",
                                                                    InvoiceImg: ""
                                                                });
                                                                // Remove from formData
                                                                setFormData((prev) => {
                                                                    const removeFromCSV = (csv, valueToRemove) => {
                                                                        if (!csv) return "";
                                                                        return csv
                                                                            .split(",")
                                                                            .map(item => item.trim())
                                                                            .filter(item => item.toLowerCase() !== String(valueToRemove).toLowerCase())
                                                                            .join(",");
                                                                    };

                                                                    return {
                                                                        ...prev,
                                                                        InvoiceNo: removeFromCSV(prev.InvoiceNo, data.InvoiceNo),
                                                                        InvValue: Number(prev.InvValue || 0) - Number(data.InvoiceValue || 0),
                                                                        EwayBill: removeFromCSV(prev.EwayBill, data.EWayBillNo),
                                                                    };
                                                                });

                                                            }}
                                                                className='edit-btn'><i className='bi bi-trash'></i></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="bottom-buttons">
                                    <button className="ok-btn" onClick={() => setModalIsOpen6(false)}>Submit</button>
                                    <button className="ok-btn" onClick={() => setModalIsOpen6(false)}>Cancel</button>
                                </div>
                            </div>


                        </div>
                    </Modal >

                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen7}
                        className="custom-modal-custCharges" contentLabel="Modal"
                        style={{
                            content: {
                                // width: '90%',
                                top: '50%',             // Center vertically
                                left: '50%',
                                whiteSpace: "nowrap",
                                height: "auto"
                            },
                        }}>
                        <div className="custom modal-content">
                            <div className="header-tittle">
                                <header>Charges</header>
                            </div>

                            <div className='container2'>
                                <form>
                                    <div className="fields2">

                                        {/* 🔘 All Select */}
                                        <div className="input-field1" style={{ display: "flex", flexDirection: "row" }}>
                                            <input
                                                type="checkbox"
                                                name="all"
                                                checked={isAllChecked}
                                                onChange={handleCheckChange}
                                                style={{ width: "12px", height: "12px", marginTop: "5px" }}
                                            />
                                            <label style={{ marginLeft: "10px", fontSize: "12px" }}>
                                                All Select
                                            </label>
                                        </div>

                                        {Object.keys(isChecked2).map((item, i) => (
                                            <div
                                                className="input-field1"
                                                style={{ display: "flex", flexDirection: "row" }}
                                                key={i}
                                            >
                                                <input
                                                    type="checkbox"
                                                    name={item}
                                                    checked={isChecked2[item] || false}
                                                    onChange={handleCheckChange}
                                                    style={{ width: "12px", height: "12px", marginTop: "5px" }}
                                                />
                                                <label style={{ marginLeft: "10px", fontSize: "12px" }}>
                                                    {item.replaceAll("_", " ")}
                                                </label>
                                            </div>
                                        ))}

                                        {Object.keys(isChecked).map((item, i) => (
                                            <div
                                                className="input-field1"
                                                style={{ display: "flex", flexDirection: "row" }}
                                                key={i}
                                            >
                                                <input
                                                    type="checkbox"
                                                    name={item}
                                                    checked={isChecked[item] || false}
                                                    onChange={handleCheckChange}
                                                    style={{ width: "12px", height: "12px", marginTop: "5px" }}
                                                />
                                                <label style={{ marginLeft: "10px", fontSize: "12px" }}>
                                                    {label[item]}
                                                </label>
                                            </div>
                                        ))}

                                    </div>

                                    <div className='bottom-buttons'>
                                        <button onClick={(e) => { handleUpdateSetup(e) }}
                                            className='ok-btn'> Submit
                                        </button>
                                        <button type="button" onClick={(e) => { setModalIsOpen7(false) }}
                                            className='ok-btn'>close
                                        </button>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal >

                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen8}
                        className="custom-modal-custCharges" contentLabel="Modal"
                        style={{
                            content: {
                                // width: '90%',

                                whiteSpace: "nowrap",
                                height: "80%",
                                top: '50%',             // Center vertically
                                left: '50%',


                            },
                        }}>
                        <div className="custom modal-content">
                            <div className="header-tittle">
                                <header>Vendor Charges Summary</header>
                            </div>

                            <div className='container2'>
                                <form>

                                    {/* Rate */}
                                    <div className="fields2">
                                        <div className="input-field1">
                                            <label>Rate</label>
                                            <input type="text" value={vendorShow.Rate || 0} readOnly />
                                        </div>
                                        <div className="input-field1">
                                            <label>Fuel Charges ({vendorShow.Fuel_Per}%)</label>
                                            <input type="text" value={vendorShow.Fuel_Charges || 0} readOnly />
                                        </div>
                                        <div className="input-field1">
                                            <label>FOV Charges ({vendorShow.Fov_Per}%)</label>
                                            <input type="text" value={vendorShow.Fov_Charges || 0} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label>Docket Charges</label>
                                            <input type="text" value={vendorShow.Docket_Charges || 0} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label>ODA Charges</label>
                                            <input type="text" value={vendorShow.ODA_Charges || 0} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label>Delivery Charges</label>
                                            <input type="text" value={vendorShow.Delivery_Charges || 0} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label>Packing Charges</label>
                                            <input type="text" value={vendorShow.Packing_Charges || 0} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label>Green Charges</label>
                                            <input type="text" value={vendorShow.Green_Charges || 0} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label>Hamali Charges</label>
                                            <input type="text" value={vendorShow.Hamali_Charges || 0} readOnly />
                                        </div>
                                        <div className="input-field1">
                                            <label>Insurance Charges</label>
                                            <input type="text" value={vendorShow.Insurance_Charges || 0} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label>Other Charges</label>
                                            <input type="text" value={vendorShow.Other_Charges || 0} readOnly />
                                        </div>
                                        <div className="input-field1">
                                            <label>Subtotal</label>
                                            <input type="text" value={vendorShow.Subtotal || 0} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label>CGST Amount ({vendorShow.CGSTPer || 0}%)</label>
                                            <input type="text" value={vendorShow.CGSTAmt || 0} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label>SGST Amount ({vendorShow.SGSTPer || 0}%)</label>
                                            <input type="text" value={vendorShow.SGSTAmt || 0} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label>IGST Amount ({vendorShow.IGSTPer || 0}%)</label>
                                            <input type="text" value={vendorShow.IGSTAmt || 0} readOnly />
                                        </div>
                                        <div className="input-field1">
                                            <label>Total GST ({vendorShow.SGSTPer + vendorShow.SGSTPer || vendorShow.IGSTPer || 0}%)</label>
                                            <input type="text" value={vendorShow.TotalGST || 0} readOnly />
                                        </div>

                                        <div className="input-field1">
                                            <label>Grand Total Amount</label>
                                            <input type="text" value={vendorShow.TotalAmount || 0} readOnly />
                                        </div>
                                    </div>

                                    <div className="bottom-buttons">
                                        <button
                                            className="ok-btn"
                                            type="button"
                                            onClick={() => setModalIsOpen8(false)}
                                        >OK</button>
                                    </div>

                                </form>
                            </div>
                        </div>

                    </Modal>

                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen10}
                        className="custom-modal-custCharges" contentLabel="Modal"
                        style={{
                            content: {
                                // width: '90%',
                                top: '50%',             // Center vertically
                                left: '50%',
                                whiteSpace: "nowrap",

                            },
                        }}>
                        <div className="custom modal-content">
                            <div className="header-tittle">
                                <header>Charges Label</header>
                            </div>

                            <div className='container2'>
                                <form>
                                    <div className="fields2">
                                        {Object.keys(label).map((key, index) => (
                                            isChecked[key] && (
                                                <div className="input-field1" key={index}>
                                                    {/* Dynamic Label */}
                                                    <label>{label[key]}</label>
                                                    {/* Input for entering Charges */}
                                                    <input
                                                        type="tel"
                                                        placeholder={label[key]}
                                                        value={label[key]}
                                                        onChange={(e) =>
                                                            setLabel({
                                                                ...label,
                                                                [key]: e.target.value
                                                            })
                                                        }
                                                    />
                                                </div>
                                            )
                                        ))}
                                    </div>
                                    <div className='bottom-buttons'>
                                        <button onClick={(e) => { handleLabelUpdate(e); setModalIsOpen10(false) }} className='ok-btn'>Submit</button>
                                        <button onClick={(e) => { e.preventDefault(); setModalIsOpen10(false) }} className='ok-btn'>close</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal >

                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen11}
                        style={{
                            content: {
                                width: '90%',
                                top: '50%',             // Center vertically
                                left: '50%',
                                height: "auto",
                                whiteSpace: "nowrap"
                            },
                        }}
                        className="custom-modal-mode" contentLabel="Modal">
                        <div className="custom-modal-content">
                            <div className="header-tittle">
                                <header>Performa Invoice Details</header>
                            </div>
                            <div className='container2'>
                                <div className="table-container" style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                                    <table className="table table-bordered table-sm">
                                        <thead className="table-info">
                                            <tr>

                                                <th>Invoice No</th>
                                                <th>Description</th>
                                                <th>HS Code</th>
                                                <th>Unit Type</th>
                                                <th>Qty</th>
                                                <th>Unit Rate</th>
                                                <th>Amount</th>
                                                <th className="w-60">Action</th>
                                            </tr>
                                        </thead>

                                        <tbody className="table-body">
                                            {/* INPUT ROW */}
                                            <tr>


                                                <td>
                                                    <input
                                                        type="text"
                                                        name="InvoiceNo"
                                                        className="form-control"
                                                        placeholder="Invoice No"
                                                        value={PinvoiceData.InvoiceNo}
                                                        style={{ textAlign: "center" }}
                                                        readOnly
                                                        onChange={handlePinvoiceDetailChange}
                                                    />
                                                </td>



                                                <td>
                                                    <CreatableSelect
                                                        className="blue-selectbooking"
                                                        classNamePrefix="blue-selectbooking"
                                                        options={allProductOptions}
                                                        value={
                                                            PinvoiceData.Description
                                                                ? allProductOptions.find(opt => opt.value === PinvoiceData.Description) || {
                                                                    value: PinvoiceData.Description,
                                                                    label: inputValue3 || PinvoiceData.Description
                                                                }
                                                                : null
                                                        }
                                                        onChange={(selectedOption) => {
                                                            setInputValue3("");

                                                            if (selectedOption) {
                                                                setPinvoiceData(prev => ({
                                                                    ...prev,
                                                                    Description: selectedOption.value,
                                                                    HSCode: selectedOption.Code
                                                                }));
                                                            } else {
                                                                setPinvoiceData(prev => ({
                                                                    ...prev,
                                                                    Description: "",
                                                                    HSCode: ""
                                                                }));
                                                            }
                                                        }}
                                                        inputValue={inputValue3}
                                                        onInputChange={(val, meta) => {
                                                            if (meta.action === "input-change") {
                                                                setInputValue3(val);

                                                                // 🔥 same as consignee → keep live sync
                                                                setPinvoiceData(prev => ({
                                                                    ...prev,
                                                                    Description: val
                                                                }));
                                                            }
                                                        }}
                                                        formatCreateLabel={(inputValue3) => `Create "${inputValue3}"`}
                                                        placeholder="Description"
                                                        isClearable
                                                        isSearchable
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            placeholder: (base) => ({
                                                                ...base,
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                width: '120px'
                                                            }),
                                                            input: (base) =>
                                                            ({
                                                                ...base,
                                                                width: "120px",
                                                            })
                                                            ,
                                                            menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                                        }}
                                                    />

                                                </td>

                                                <td>
                                                    <input
                                                        type="text"
                                                        name="HSCode"
                                                        placeholder="HS Code"
                                                        className="form-control"
                                                        value={PinvoiceData.HSCode}
                                                        style={{ textAlign: "center" }}
                                                        onChange={handlePinvoiceDetailChange}
                                                    />
                                                </td>

                                                <td >
                                                    <CreatableSelect
                                                        className="blue-selectbooking"
                                                        classNamePrefix="blue-selectbooking"
                                                        options={unitTypeOptions}
                                                        value={
                                                            PinvoiceData.UnitType
                                                                ? unitTypeOptions.find(opt => opt.value === PinvoiceData.UnitType)
                                                                : null
                                                        }
                                                        onChange={(selectedOption) => {
                                                            setPinvoiceData(prev => ({
                                                                ...prev,
                                                                UnitType: selectedOption.value,
                                                            }));
                                                        }}
                                                        inputValue={inputValue2}
                                                        onInputChange={(val, meta) => {
                                                            if (meta.action === "input-change") {
                                                                // ✅ Immediately reflect what user is typing
                                                                setInputValue2(val);

                                                                // ✅ Also update formData live so label and value stay in sync
                                                                setPinvoiceData((prev) => ({
                                                                    ...prev,
                                                                    UnitType: val,
                                                                }));
                                                            }
                                                        }}

                                                        formatCreateLabel={(inputValue2) => `Create "${inputValue2}"`}
                                                        isSearchable
                                                        placeholder="Unit Type"
                                                        menuPlacement="bottom"          // ✅ force dropdown below
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            placeholder: (base) => ({
                                                                ...base,
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                width: '120px'
                                                            }),
                                                            input: (base) =>
                                                            ({
                                                                ...base,
                                                                width: "120px",
                                                            })
                                                            ,
                                                            menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                                        }}
                                                    />



                                                </td>

                                                <td>
                                                    <input
                                                        type="number"
                                                        name="Qty"
                                                        placeholder="Qty"
                                                        className="form-control"
                                                        value={PinvoiceData.Qty}
                                                        style={{ textAlign: "center" }}
                                                        onChange={handlePinvoiceDetailChange}
                                                    />
                                                </td>

                                                <td>
                                                    <input
                                                        type="number"
                                                        name="UnitRate"
                                                        placeholder="Unit Rate"
                                                        className="form-control"
                                                        value={PinvoiceData.UnitRate}
                                                        style={{ textAlign: "center" }}
                                                        onChange={handlePinvoiceDetailChange}
                                                    />
                                                </td>

                                                <td>
                                                    <input
                                                        type="number"
                                                        name="Amount"
                                                        placeholder="Amount"
                                                        className="form-control"
                                                        value={PinvoiceData.Amount}
                                                        style={{ textAlign: "center" }}
                                                        readOnly
                                                    />
                                                </td>

                                                <td>
                                                    <button
                                                        className="ok-btn"
                                                        style={{ width: "40px", height: "30px", margin: "0px 10px", marginTop: "3px", paddingBottom: "15px", fontSize: "22px" }}
                                                        onClick={handlePinvoiceAddRow}
                                                    >
                                                        <i className="bi bi-plus"></i>
                                                    </button>
                                                </td>
                                            </tr>

                                            {/* SUBMITTED ROWS */}
                                            {PinvoicesubmittedData.map((data, index) => (
                                                <tr key={index}>

                                                    <td>{data.InvoiceNo}</td>
                                                    <td>{data.Description}</td>
                                                    <td>{data.HSCode}</td>
                                                    <td>{data.UnitType}</td>
                                                    <td>{data.Qty}</td>
                                                    <td>{data.UnitRate}</td>
                                                    <td>{data.Amount}</td>
                                                    <td>
                                                        <button
                                                            className="edit-btn"
                                                            onClick={() => {
                                                                setPinvoiceData(data);
                                                                // setInputValue2(data.UnitType)
                                                                // setInputValue3(data.Description)
                                                                setEditIndex(index);
                                                            }}
                                                        >
                                                            <i className="bi bi-pen"></i>
                                                        </button>

                                                        <button
                                                            className="edit-btn"
                                                            onClick={() => {
                                                                setPinvoiceSubmittedData(
                                                                    PinvoicesubmittedData.filter((_, i) => i !== index)
                                                                );

                                                            }}
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>
                                <form action="" style={{ backgroundColor: "white", justifyContent: "center" }}>
                                    <div className="fields2">
                                        <div className="input-field1">
                                            <label htmlFor="">Note.</label>
                                            <input type="text" placeholder="Note." value={note} onChange={(e) => setNote(e.target.value)} />
                                        </div>

                                        <div className="input-field1">
                                            <label htmlFor="">Total Invoice Value</label>
                                            <input type="text" placeholder="Total Invoice Value" value={totalInvoiceValue} readOnly />
                                        </div>
                                    </div>
                                </form>
                                <div className="bottom-buttons">
                                    <button className="ok-btn" onClick={() => setModalIsOpen11(false)}>Submit</button>
                                    <button className="ok-btn" onClick={() => setModalIsOpen11(false)}>Cancel</button>
                                </div>
                            </div>


                        </div>
                    </Modal >

                </div >

            </div >
        </>
    );
};

export default Booking;